$(function() {
    cartDrawerUpdate();
    initFeaturedCollectionSlider();
    initMobileNavSlider();
    checkUrlForFilter();
    onLoadUpdateCharacterCount();
    onLoadCheckNewsletterTrigger();
    drawerUpsellGridHeight();
    setMobilePromoGridHeight();
    onloadToggleDonation();
    dynamicHeightSideNav();
    onLoadCheckAnnouncementBar();
    initYmalSlider();
    mobileAccountOrderColSpan();
    updateStoreSelectorText();
    setMegamenuWidth();
    removeIncompleteBundleSet();
    gwpMinCartQty();
    colPurchaseGwp();
    minSpendGwp();
    collabMinSpendGwp();
    tierGwp();
    removePastGwp();
    moveStickyATC();
    updateShippingContent();

    updateMixMatchOverlayImages();
    filterMixMatchMediaGallery();
    setMixMatchStickyTop();
    initMixMatchStickyATC();
    disableGalleryViewerForMixMatch();
    initHotspotSlider(); 

    validateGwpBeforeCheckout();

    document.addEventListener('on:cart:after-merge', (event) => {
        if (jscGwpMergeSkips > 0) {
            jscGwpMergeSkips--;
            return;
        }
        setTimeout(function() { 
            gwpMinCartQty();
            colPurchaseGwp();
            minSpendGwp();
            collabMinSpendGwp();
            tierGwp();
        }, 500); // Note: Added setTimeout bcos when click remove btn it doesn't trigger immediately."
      });

    document.addEventListener('on:cart-drawer:after-close', (event) => {
        // show chat widget
        $('#gorgias-chat-container').show();
        $('#bon-loyalty-btn').css('opacity', '1');
    });
});

// Start: gwp min cart qty
gwpMinCartQty = () => {
    var $gwp_min_cart_qty = $('.jsc-gwp-min-cart-qty');
    $gwp_min_cart_qty.each(function(index, $gwpEl) {
        var newIndex = index + 1;

        var $accumulate_qty = 0;
        var $purchase_qty = parseInt($($gwpEl).attr('purchaseQty'));
        var $gift_inventory = parseInt($($gwpEl).attr('gift-inventory'));

        if ($gift_inventory > 0){
            $(`.jsc-cart-item-qtycol-${newIndex}`).each(function() {
                var $item_qty = parseInt($(this).find('.cart-item__not-image').find('.cart-item__quantity .quantity .cart-item__quantity-input').attr('data-initial-value'));
                
                if (!isNaN($item_qty)) {
                    $accumulate_qty += $item_qty;
                }
            });

            var $gift_qty = Math.floor($accumulate_qty / $purchase_qty);

            if ($gift_qty > $gift_inventory){
                $gift_qty = $gift_inventory;
            }
            
            var $giftHandle = $($gwpEl).attr('gift-handle');
            var $giftVid = $($gwpEl).attr('gift-vid');

            var $isGiftInCart = false; 
            var $isUpdate = false;
            var $isDelete = true;

            var $gift_key = '';
            var $isGiftInCartQty = 0;
            var $obj = {};
            
            fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                
                cart.items.forEach(item => {
                    var $productHandle = item.handle; 
                    var $productProps = item.properties;
                    if (($productHandle == $giftHandle) && ($productProps['_Promo'] == 'Free Gift')){
                        $isGiftInCart = true; 
                        $isGiftInCartQty = item.quantity; 

                        if ($gift_qty != item.quantity){
                            $gift_key = item.key;
                            $isUpdate = true;
                        }
                    }
            
                });

                if (($isGiftInCart) && ($isUpdate)){
                    cartJsUpdate($gift_key,$gift_qty,{});
                    console.log('update',$gift_qty);
                }

                if (($isGiftInCart == false) && ($gift_qty > 0)){
                    $obj['_Promo'] = 'Free Gift';
                    cartJsAtc($giftVid,$gift_qty,$obj);
                }
        
                if ($accumulate_qty >= $gift_qty){
                    $isDelete = false;
                }

                if (($isGiftInCart) && ($isDelete)){
                    cartJsUpdate($gift_key,0);
                    console.log('remove',$gift_qty);
                }

            })
            .catch(error => console.error('Error fetching cart:', error));
        }
    });
}
// End: gwp min cart qty

// Start: col purchase gwp
colPurchaseGwp = () => {
    var $gwp_inventory = parseInt($('.jsc-col-purchase-gwp').attr('gwp-inventory'));
    var $gwp_vid = $('.jsc-col-purchase-gwp').attr('gwp-vid');
    
    var $obj = {};
    var $gwpItemCount = 0;
    var $gwp_key = null;
    var $isGiftInCart = false; 

    if ($gwp_inventory > 0) {

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            
            cart.items.forEach(item => {
                var $productProps = item.properties;

                if ($productProps['_ColPurchaseGwp'] == 'Free Gift') {
                    $isGiftInCart = true;
                    $gwp_key = item.key;  
                    $gwpItemCount = item.quantity;  
                }
            });

            if (!$isGiftInCart && $('.jsc-cart-item-colPurchase').length > 0) {
                $obj['_ColPurchaseGwp'] = 'Free Gift';
                cartJsAtc($gwp_vid, 1, $obj); 
            }

            if ($isGiftInCart) {
                if ($gwpItemCount > 1) {
                    cartJsUpdate($gwp_key, 1, {});  ;
                }
            }

            if ($('.jsc-cart-item-colPurchase').length === 0 && $isGiftInCart) {
                cartJsUpdate($gwp_key, 0, {});
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }
}
// End: col purchase gwp


// Start: Min spend gwp
minSpendGwp = () =>{
    var $gwp_inventory = parseInt($('.jsc-min-spend-gwp').attr('gwp-inventory'));
    var $gwp_vid = $('.jsc-min-spend-gwp').attr('gwp-vid');
    var $min_spend = parseInt($('.jsc-min-spend-gwp').attr('min-spend'));
    var $applied_each = $('.jsc-min-spend-gwp').attr('gwp-applied-each');
    var $max_gwp_qty = parseInt($('.jsc-min-spend-gwp').attr('max-gwp-qty'));
    console.log('$applied_each: ', $applied_each);
    
    var $isGiftInCart = false;
    var $gwp_key = null;
    var $isGiftInCartQty = 0;

    if ($gwp_inventory > 0) {

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {

            var $finalTotal = 0;

            // Calculate the total price of included items
            $('.jsc-cart-item-minSpendCol').each(function() {
                var $itemOriginalPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
                var $itemQuantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));

                $itemOriginalPrice =  $itemOriginalPrice * $itemQuantity;
                $finalTotal += $itemOriginalPrice;
            });

            cart.items.forEach(item => {
                var $productProps = item.properties;

                if ($productProps['_MinSpendGwp'] === 'Free Gift') {
                    $isGiftInCart = true;
                    $gwp_key = item.key;
                    $isGiftInCartQty = item.quantity; 
                }
            });

            var $gift_qty = 1;
            if ($applied_each === 'true' || $applied_each === true && $finalTotal >= $min_spend) {
                $gift_qty = Math.floor($finalTotal / $min_spend);
                if ($max_gwp_qty > 0 && $gift_qty > $max_gwp_qty) { 
                  $gift_qty = $max_gwp_qty; 
                } 
                if ($gift_qty > $gwp_inventory){
                    $gift_qty = $gwp_inventory;
                }
            }
            console.log($finalTotal,'$finalTotal',$min_spend, $isGiftInCart, $gift_qty)

            if($finalTotal >= $min_spend && $isGiftInCart == false) { // adding GWP
                cartJsAtc($gwp_vid, $gift_qty, {'_MinSpendGwp': 'Free Gift'});
            }
            else if($finalTotal < $min_spend && $isGiftInCart) { // removing GWP
                cartJsUpdate($gwp_key, 0, {});
            }
            else if($finalTotal >= $min_spend && $isGiftInCart) { // update GWP qty to 1
                if($isGiftInCartQty != $gift_qty) {
                  console.log('updatingGWP: ', $gift_qty);
                  cartJsUpdate($gwp_key, $gift_qty, {'_MinSpendGwp': 'Free Gift'});
                }
            }

        })
        .catch(error => console.error('Error fetching cart:', error));
    }

}
// End: Min spend gwp

// Start: Tier GWP
tierGwp = () => {
    var $tierGwp = $('.jsc-tier-gwp');
    if ($tierGwp.length > 0) {
        var eligibleCartTotal = 0;
        var gwpInfo = {};

        $('.jsc-cart-item-tier-col').each(function() {
            var unitPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
            var quantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));

            var totalPrice = unitPrice * quantity;
            eligibleCartTotal += totalPrice;
        });

        $tierGwp.each(function() {
            var gwpInventory = parseInt($(this).attr('gwp-inventory'));
            var minSpend = parseInt($(this).attr('min-spend'));
            var gwpId = parseInt($(this).attr('gwp-vid'));

            if (gwpInventory > 0) {
                if (eligibleCartTotal >= minSpend) {
                    gwpInfo[gwpId] = (gwpInfo[gwpId] || 0) + 1;
                }
            }
        });

        $tierGwp.each(function() {
            var gwpId = parseInt($(this).attr('gwp-vid'));
            var gwpInventory = parseInt($(this).attr('gwp-inventory'));
            var isGwpInCart = false;
            var inCartQty = 0;
            var minSpend = parseInt($(this).attr('min-spend'));
            var key = null;

            if (gwpInventory > 0) {
                fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    cart.items.forEach(item => {
                        var itemProps = item.properties;
                        if (itemProps['_TierGwp'] == 'Free Gift' && item.id == gwpId) {
                            isGwpInCart = true;
                            inCartQty = item.quantity;
                            key = item.key;
                        }
                    });

                    if(isGwpInCart == false && gwpId in gwpInfo && eligibleCartTotal >= minSpend) {
                        cartJsAtc(gwpId, gwpInfo[gwpId], {'_TierGwp': 'Free Gift'});
                    }
                    else if (isGwpInCart == true && !(gwpId in gwpInfo)) {
                        cartJsUpdate(key, 0, {});
                    }
                    else if(isGwpInCart == true && gwpId in gwpInfo && inCartQty != gwpInfo[gwpId]) {
                        cartJsUpdate(key, gwpInfo[gwpId], {'_TierGwp': 'Free Gift'});
                    }
                });
            }
        });
    }
}
// End: Tier GWP

// Start: Collab Min spend GWP
collabMinSpendGwp = () =>{
  var $min_spend_collab_gwp = $('.jsc-min-spend-collab-gwp');
  $min_spend_collab_gwp.each(function(index, $gwpEl) {
    var newIndex = index + 1;
    var tpb_gwp_vid = $($gwpEl).attr('tpb-gwp-vid');
    var tpb_gwp_available = $($gwpEl).attr('tpb-gwp-available');
    var collab_gwp_vid = $($gwpEl).attr('collab-gwp-vid');
    var collab_gwp_available = $($gwpEl).attr('collab-gwp-available');
    var min_spend = parseInt($($gwpEl).attr('min-spend'));

    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var tpb_item_total = 0;
      var collab_item_total = 0;
      var cart_total = 0;
      var is_tpb_gwp_in_cart = false;
      var tpb_gwp_in_cart_qty = 0;
      var tpb_gwp_key = null;
      var is_collab_gwp_in_cart = false;
      var collab_gwp_in_cart_qty = 0;
      var collab_gwp_key = null;
      var add_tpb_gwp = false;
      var update_tpb_gwp = false;
      var remove_tpb_gwp = false;
      var add_collab_gwp = false;
      var update_collab_gwp = false;
      var remove_collab_gwp = false;

      // calculate total price
      $(`.jsc-cart-item-collab-gwp-${newIndex}`).each(function() {
        var $itemOriginalPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
        var $itemQuantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));
        $itemOriginalPrice =  $itemOriginalPrice * $itemQuantity;
        cart_total += $itemOriginalPrice;

        if ($(this).hasClass(`jsc-cart-item-tpb-min-spend-${newIndex}`)) {
          tpb_item_total += $itemOriginalPrice;
        }

        if ($(this).hasClass(`jsc-cart-item-collab-min-spend-${newIndex}`)) {
          collab_item_total += $itemOriginalPrice;
        }
      });

      // check gwp in cart
      cart.items.forEach(item => {
        var item_properties = item.properties;

        if (item_properties['_CollabMinSpendGwp'] === 'TPB Gift') {
          is_tpb_gwp_in_cart = true;
          tpb_gwp_key = item.key;
          tpb_gwp_in_cart_qty = item.quantity; 
        }
        if (item_properties['_CollabMinSpendGwp'] === 'Collab Gift') {
          is_collab_gwp_in_cart = true;
          collab_gwp_key = item.key;
          collab_gwp_in_cart_qty = item.quantity; 
        }
      });

      // update gwp in cart
      if (tpb_gwp_available == 'true' || collab_gwp_available == 'true') {
        if (cart_total >= min_spend) {
          if (collab_item_total > 0) {
            if (collab_gwp_available == 'true') { // add collab gwp
              if (is_collab_gwp_in_cart) {
                if (collab_gwp_in_cart_qty > 1) {
                  update_collab_gwp = true;
                }
              }
              else {
                add_collab_gwp = true;
              }

              if (is_tpb_gwp_in_cart) {
                remove_tpb_gwp = true;
              }
            }
            else { 
              if (is_collab_gwp_in_cart) {
                remove_collab_gwp = true;
              }

              if (tpb_item_total >= min_spend) { // replace collab gwp with tpb gwp
                if (tpb_gwp_available == 'true') {
                  if (is_tpb_gwp_in_cart) {
                    if (tpb_gwp_in_cart_qty > 1) {
                      update_tpb_gwp = true;
                    }
                  }
                  else {
                    add_tpb_gwp = true;
                  }
                }
                else {
                  if (is_tpb_gwp_in_cart) {
                    remove_tpb_gwp = true;
                  }
                }
              }
              else {
                if (is_tpb_gwp_in_cart) {
                  remove_tpb_gwp = true;
                }
              }
            }
          }
          else { // no collab, add tpb gwp
            if (is_collab_gwp_in_cart) {
              remove_collab_gwp = true;
            }

            if (tpb_gwp_available == 'true') {
              if (is_tpb_gwp_in_cart) {
                if (tpb_gwp_in_cart_qty > 1) {
                  update_tpb_gwp = true;
                }
              }
              else {
                add_tpb_gwp = true;
              }
            }
            else {
              if (is_tpb_gwp_in_cart) {
                remove_tpb_gwp = true;
              }
            }
          }
        }
        else { // not hit min spend, remove gwp if is in the cart
          if (is_tpb_gwp_in_cart) {
            remove_tpb_gwp = true;
          }
          if (is_collab_gwp_in_cart) {
            remove_collab_gwp = true;
          }
        }
      }
      else { // both gwp not available, remove if is in the cart
        if (is_tpb_gwp_in_cart) {
          remove_tpb_gwp = true;
        }
        if (is_collab_gwp_in_cart) {
          remove_collab_gwp = true;
        }
      }

      if (remove_tpb_gwp) {
        cartJsUpdate(tpb_gwp_key, 0, {});
      }
      if (remove_collab_gwp) {
        cartJsUpdate(collab_gwp_key, 0, {});
      }

      if (add_tpb_gwp) {
        cartJsAtc(tpb_gwp_vid, 1, {'_CollabMinSpendGwp': 'TPB Gift'});
      }
      if (update_tpb_gwp) {
        cartJsUpdate(tpb_gwp_key, 1, {'_CollabMinSpendGwp': 'TPB Gift'});
      }

      if (add_collab_gwp) {
        cartJsAtc(collab_gwp_vid, 1, {'_CollabMinSpendGwp': 'Collab Gift'});
      }
      if (update_collab_gwp) {
        cartJsUpdate(collab_gwp_key, 1, {'_CollabMinSpendGwp': 'Collab Gift'});
      }
    });
  });
}
// End: Collab Min spend GWP

// Start: remove past GWP
removePastGwp = () => {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        cart.items.forEach(item => {
            var key = item.key;
            var id = item.id;
            var properties = item.properties;

            if(properties['_Promo'] != undefined || properties['_ColPurchaseGwp'] != undefined || properties['_MinSpendGwp'] != undefined || properties['_TierGwp'] != undefined || properties['_CollabMinSpendGwp'] != undefined) {
                if(!jscIsKnownGwpVariant(id)) {
                    cartJsUpdate(key, 0, {});
                }
            }
        });
    });
}
// End: remove past GWP

bindRemove = (evt) => {
    var $this = $(evt);
    var $actionVal = 'remove-';
    removeBindClick($this,$actionVal);
}

removeBindClick = (e, actionVal) => {
    var $bindId = e.attr('data-bindId');
    $('.' + actionVal + $bindId).each(function() {
        this.click();
    });
    
    setTimeout(function() {
        $.getJSON('/cart.js', function(cart) {
            var $count = cart.item_count;
            $('.cart-link__count').text($count);
            $('.jsc-drawer-item-count .jsc-item-count').text($count);
        });
    }, 500);
}

bindPlusQty = (evt) => {
    var $this = $(evt);
    var $actionVal = 'plus-';
    plusMinusBindClick($this,$actionVal);
}

bindMinusQty = (evt) => {
    var $this = $(evt);
    var $actionVal = 'minus-';
    plusMinusBindClick($this,$actionVal);
}

plusMinusBindClick = (e,actionVal) =>{
    var $bindId = e.attr('data-bindId');
    setTimeout(function(){
      $('.'+actionVal+$bindId)[0].click();
      console.log($('.'+actionVal+$bindId)[0],'bbb')
      setTimeout(function(){
        $.when($.getJSON('/cart.js', function(cart) {
          $count = cart.item_count;
          })).then(function(){
            var cartCount = $('.cart-link__count');
            cartCount.text($count);

            var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
            drawerItemCount.text($count);
          });
       },500);
    },500);
}


$('#_personalisetnc').on('change', function() {
    if ($(this).is(':checked')) {
      $('#_personalisetncerror').hide();
      $('.jsc-personalise-check-atc').css('border-color','#000'); 
    }
});

personaliseAddToCart = (e) => {
    if ($('#personalise-input').val() == "") {
        $('#_personaliseTxtError').show();

        if ($(window).width() < 480 ){
            $('html, body').animate({
                scrollTop: $('#_isPersonalisation').offset().top
            }, 500); 
        }
    } 
    else if (!$('#_personalisetnc').is(':checked')) { 
        $('#_personalisetncerror').show();
        $('#_personaliseTxtError').hide();
        $('.jsc-personalise-check-atc').css('border-color','#ff0000');
    }else{
        $('#_personalisetncerror').hide();
        $('#_personaliseTxtError').hide();
        $('.jsc-personalise-check-atc').css('border-color','#000'); 
        var $this = $(e);
        var $prod = {};
        var $prodCost_add = {};
        var $prodVid = parseInt($('.jsc--getMainId').val());
        var $prodCost_vid = parseInt($this.attr('data-prodCostVid'));
        var $qty = parseInt($('#personalise_quantity').val());
        var $prodTitle = $this.attr('data-prodTitle');
        var $prodCost_title = $this.attr('data-prodCostTitle');
        var jsonObj = [];

        var $inputText = $('#personalise-input').val();
        var $fontType = $('.jsc-font-type-list .font-selected').attr('font-family');
        var $enableSpecialChar = $('.jsc-font-type-list .font-selected').attr('data-special-char');
        var $threadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolor');
        // var $posLayout = $('.jsc-position-list .layout-selected').attr('value');

        $prodCost_add['_Personalise'] = $prodTitle;
        $prodCost_add['_Personalisation'] = $inputText;
        $prodCost_add['_Font Type'] = $fontType;
        // $prodCost_add['_Position'] = $posLayout;
        $prodCost_add['_Thread Colour'] = $threadColor;

        $prod['_Main Product'] = $prodCost_title;
        $prod['Personalisation'] = $inputText;
        $prod['Font Type'] = $fontType;
        // $prod['Position'] = $posLayout;
        $prod['Thread Colour'] = $threadColor;

        $prodCost_add['_BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$inputText+'-'+$fontType+'-'+$enableSpecialChar+'-'+$threadColor;
        $prod['_BindID'] = $prodVid+'-'+$prodCost_vid+'-'+$inputText+'-'+$fontType+'-'+$enableSpecialChar+'-'+$threadColor;

        var item = {};
        item ["id"] = $prodCost_vid;
        item ["quantity"] = $qty;
        item ["properties"] = $prodCost_add;
        jsonObj.push(item);
        var item = {};
        item ["id"] = $prodVid;
        item ["quantity"] = $qty;
        item ["properties"] = $prod;
        jsonObj.push(item);


        CartJS.addItems(jsonObj,
        {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                console.log('success');
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);
                    onloadToggleDonation();
                    toggleUpsellBanner(cart);
                });

                if(window.location.href.includes('/cart')) {
                    location.reload();
                }
                else {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer
                }
                    
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
        });
    
    }

} 


changeFont = (e) => {
    $('.jsc-font-type-list').children('.font-option').removeClass('font-selected');
    $(e).addClass('font-selected');
    console.log('change font');
    var getText = $('#personalise-input').val();
    var enableSpecialCharacter = $(e).attr('data-special-char');

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
        // Construct regular expression pattern dynamically including icon texts
        var iconTexts = $('.jsc-font-icon-list .icon-text').map(function() {
            return $(this).attr('data-icon');
        }).get().join('');
        var regexPattern = '[^a-zA-Z0-9' + iconTexts + ']';
        getText = getText.replace(new RegExp(regexPattern, 'g'), '');
    } else {
        $('.jsc-disabled-special-characters').hide();  
    }

    var getFontFamily = $(e).attr('font-family').toString();
    var getFontSize = $(e).attr('font-size');
    var getMobFontSize = $(e).attr('mob-font-size');
    var getCharLimit = $(e).attr('data-character');

    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-family','"'+getFontFamily+'"');
    $('#personalisation-text').css('font-size',getFontSize);
   
    if ($(window).width() < 480 ){
        $('#personalisation-text').css('font-size',getMobFontSize); 
    }

    $('.personalise-char-limit-desc .limit').text(getCharLimit);
    $('#personalise-input').attr('maxlength',getCharLimit);
   
    // Truncate text if it exceeds the character limit
    if (getText.length > getCharLimit) {
        getText = getText.substring(0, getCharLimit);
    }

    constructTextOverlay(getText);

    $('#personalise-input').val(getText);
    $('.jsc-your-font .selected-fonttype').text(getFontFamily);
}

changeColor = (e) => {
    $('.jsc-threadcolor-list').children('.threadcolor-option').removeClass('tcolor-selected');
    $(e).addClass('tcolor-selected');

    var getColor = $(e).attr('data-threadcolor');
    var getColorCode = $(e).attr('data-threadcolorcode');

    $('#personalisation-text').css('color',getColorCode);
    $('.jsc-thread-color .selected-threadcolor').text(getColor);

    var getText = $('#personalise-input').val();
    constructTextOverlay(getText);
}

// changePosLayout = (e) => {
//     $('.jsc-position-list').children('.position-layout-option').removeClass('layout-selected');
//     $(e).addClass('layout-selected');

//     var _ltop = $(e).attr('data-ltop');
//     var _lleft = $(e).attr('data-lleft');
//     var _topTransform = $(e).attr('data-topTransform');
//     var _leftTransform =  $(e).attr('data-leftTransform');
  
//     $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
//     $(".personalisation-text-overlay").css( "top", _ltop);
//     $(".personalisation-text-overlay").css( "left", _lleft);

//     var getPosition = $(e).attr('value');
//     $('.jsc-text-position .selected-position').text(getPosition);
// }

addIconText = (e) => {
    var getIcon = $(e).attr('data-icon');
    
    // Check if adding the icon exceeds the maximum length
    var maxLength = parseInt($('#personalise-input').attr('maxlength'));
    if ($('#personalise-input').val().length + getIcon.length > maxLength) {
        return; // Exit function if exceeding max length
    }

    // Append the icon text to the input value
    $('#personalise-input').val(function(_, currentValue) {
        return currentValue + getIcon;
    });
    

    var getText = $('#personalise-input').val();
    constructTextOverlay(getText);

}

constructTextOverlay = (inputText) => {
  
    var iconTextEach = $('.jsc-font-icon-list .icon-text');

    iconTextEach.each(function(){
        var svgIcon = $(this).attr('data-icon');
        var svgCode = $(this).find('svg').prop('outerHTML');
        var regex = new RegExp(svgIcon, 'g');
  
        if (inputText.includes(svgIcon)) {
            // Replace hex icon with SVG code
            inputText = inputText.replace(regex, svgCode);
        }
    });
  
    // Update the text overlay
    $('#personalisation-text').html(inputText);

    var getThreadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolorcode');
    $('#personalisation-text').css('color',getThreadColor);

    var getFontSize = $('.jsc-font-type-list .font-selected').attr('font-size');
    var getMobFontSize = $('.jsc-font-type-list .font-selected').attr('mob-font-size');
 
    $('#personalisation-text').find('svg').each(function() {
        if ($(window).width() < 480 ){
            $(this).css({
                'width': getMobFontSize,
                'height': getMobFontSize
            }); 
        }else{ 
            $(this).css({
                'width': getFontSize,
                'height':  getFontSize 
            });
        }
    });
    
    $('#personalisation-text').find('svg').each(function() {
        $(this).children().css({
            'fill': getThreadColor
        });
    });

}

toggleIconList= (e) => {
    $(".personalise-plus-icon").toggle(); 
    $(".personalise-minus-icon").toggle(); 
    $('.jsc-your-monogram-icon').toggle();
}

inputPersonaliseTxt = (e) => {
    $('#_personaliseTxtError').hide();
    var getText = $('#personalise-input').val();
    var getThreadColor = $('.jsc-threadcolor-list .tcolor-selected').attr('data-threadcolorcode');

    var selectedFont = $('.jsc-font-type-list').children('.font-option.font-selected');
    var enableSpecialCharacter = selectedFont.attr('data-special-char');

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
        // Construct regular expression pattern dynamically including icon texts
        var iconTexts = $('.jsc-font-icon-list .icon-text').map(function() {
            return $(this).attr('data-icon');
        }).get().join('');
        var regexPattern = '[^a-zA-Z0-9' + iconTexts + ']';
        getText = getText.replace(new RegExp(regexPattern, 'g'), '');
    } else {
        $('.jsc-disabled-special-characters').hide();  
    }

    constructTextOverlay(getText);

    $('#personalise-input').val(getText);
    $('#personalisation-text').css('color',getThreadColor);

    // click customise alt image
    $('.carousel.thumbnails .slider__item._altTxtCustomise img').click();
}

showPersonalise  = (e) => {
    $('#_isPersonalisation').show();
    $('.jsc-personalise-btn').hide();
    $('.main-prod-buy-buttons-row').hide();

    var selectedPosition = $('.jsc-position-list .position-layout-option').first();
    var getPosition = selectedPosition.attr('value');
    selectedPosition.addClass('layout-selected');

    var _ltop = selectedPosition.attr('data-ltop');
    var _lleft = selectedPosition.attr('data-lleft');
    var _topTransform = selectedPosition.attr('data-topTransform');
    var _leftTransform = selectedPosition.attr('data-leftTransform');
  
    $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
    $(".personalisation-text-overlay").css( "top", _ltop);
    $(".personalisation-text-overlay").css( "left", _lleft);

    var selectedFont = $('.jsc-font-type-list').children('.font-option.font-selected');
    var selectedThread = $('.jsc-threadcolor-list').children('.threadcolor-option.tcolor-selected');

    var getColor = selectedThread.attr('data-threadcolorcode');
    var getColorVal = selectedThread.attr('data-threadcolor');
    var getFontFamily = selectedFont.attr('font-family').toString();
    var getFontSize = selectedFont.attr('font-size');
    var getMobFontSize = selectedFont.attr('mob-font-size');
    var getCharLimit = selectedFont.attr('data-character');
    var enableSpecialCharacter = selectedFont.attr('data-special-char');

    $('.jsc-your-font .selected-fonttype').text(getFontFamily);
    $('.jsc-thread-color .selected-threadcolor').text(getColorVal);
    $('.jsc-text-position .selected-position').text(getPosition);

    $('#personalisation-text').css('font-size',getFontSize);
    $('#personalisation-text').css('font-family','"'+getFontFamily+'"');

    if ($(window).width() < 480 ){
        $('#personalisation-text').css('font-size',getMobFontSize); 
    }

    $('.personalise-char-limit-desc .limit').text(getCharLimit);
    $('#personalise-input').attr('maxlength',getCharLimit);
    $('#personalisation-text').css('color',getColor);

    if (enableSpecialCharacter == 'n'){
        $('.jsc-disabled-special-characters').show(); 
    }else{
        $('.jsc-disabled-special-characters').hide();  
    }

    // change overlay text position
    var _ltop = $(e).attr('data-ltop');
    var _lleft = $(e).attr('data-lleft');
    var _topTransform = $(e).attr('data-topTransform');
    var _leftTransform =  $(e).attr('data-leftTransform');
  
    $(".personalisation-text-overlay").attr('style', 'transform: translate('+_leftTransform+','+_topTransform+')');
    $(".personalisation-text-overlay").css( "top", _ltop);
    $(".personalisation-text-overlay").css( "left", _lleft);

}
removePersonalise = () => {
    $('#_isPersonalisation').hide();
    $('.jsc-personalise-btn').show();
    $('.main-prod-buy-buttons-row').show();
    $('#personalisation-text').text('');
    $('.jsc-monogram-text-input-group.jsc-your-monogram-text input').val('');
}

dynamicHeightSideNav = () => {
    var stickyContainer = $('.jsc-side-nav__sticky-container');
    var sideNavSection = $('.jsc-side-nav-container');
   
    if ($(window).width() > 1299 && stickyContainer.length > 0 && sideNavSection.length > 0) {
        var sideNavSectionBottom = 0;
        var stickyContainerTop = stickyContainer.offset().top;

        sideNavSection.each(function(index, element) {
            var $currentElement = $(element);
            if (index === $('.jsc-side-nav-container').length - 1) { // Check if current element is the last one
                sideNavSectionBottom = $currentElement.offset().top + $currentElement.outerHeight();
            }
        });

        stickyContainer.css('height', (sideNavSectionBottom - stickyContainerTop) + 'px');
    }

}

onloadToggleDonation = () => {
    var donation_is_incart = false;
    var donation_prodId = parseInt($('.jsc-drawer-product-donation input').data('productid'));

    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){
        if(cartItems.length == 0) {
            $('.jsc-drawer-product-donation').css('display', 'none');
        }
        else {
            $('.jsc-drawer-product-donation').css('display', 'flex');
            for (var d = 0; d < cartItems.length; d++) {
                var itemProdId = cartItems[d].product_id;

                if (itemProdId == donation_prodId) {
                    donation_is_incart = true;      
                }
            }

            if(donation_is_incart == true) {
                $('.jsc-drawer-product-donation input').prop('checked', true);
                $('.jsc-donation-variant-list').show();
            }
            else {
                $('.jsc-drawer-product-donation input').prop('checked', false);
                $('.jsc-donation-variant-list').hide();
            }
        }
    });
}

toggleVariantDonation = (d_prodId, d_vid) => {
    var changeDonation = true;
    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){

        for (var d = 0; d < cartItems.length; d++) {
            var itemProdId = cartItems[d].product_id
            var itemId = cartItems[d].id;
            if (itemProdId == d_prodId) {
                if (itemId == d_vid) {
                    changeDonation = false;
                } else {
                    CartJS.updateItemById(itemId, 0);
                }
            }

          
        }

    if (changeDonation) {
        cartJsAtc(d_vid, 1, {'_Donation': 'Yes'});
    }

    });
}

toggleDonation = (e) => {
    var donation_first_vid = parseInt($(e).data('vid'));
    var donation_prodId = parseInt($(e).data('productid'));
    var addDonation = true;

    $.when($.getJSON('/cart.js', function(cart) {
        cartItems = cart.items;
    })).then(function(cart){
        for (var d = 0; d < cartItems.length; d++) {
            var productId = cartItems[d].product_id;;
            if (productId == donation_prodId) {
                var itemId = cartItems[d].id;
                addDonation = false;      
            }
        }

        if(addDonation == true) {
            cartJsAtc(donation_first_vid, 1, {'_Donation': 'Yes'});
        }
        else {
            cartJsUpdate(itemId, 0, {});
        }
    });

}

$(document).click(function(e) {
    if ($(window).width() < 480 ){
        if ($('.jsc-faq-index-parent').length > 0) {
            if (!$(e.target).closest('.jsc-overwrite-mobile-faq-index__heading').length) {
                $(".jsc-faq-index-parent").hide();
            }
        }
    }
});

mobileFaqToggle= () => {
    if ($(window).width() < 480 ){
        $('.jsc-faq-index-parent').toggle();
    }
}

jscFaqSelect = (e) => {
    if ($(window).width() < 480 ){
        var text_selected = $(e).text();
        $('.faq-index__heading').text(text_selected);
    }
}

initFeaturedCollectionSlider = () => {
    $('.section-featured-collection .collection-slider-row .jsc-slider .product-grid').flickity({
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        freeScroll: true,
        contain: true
    })
}

flickitySelectPrev = () => {
    var slider = $('.collection-slider-row .product-grid');
    slider.flickity('previous');
}

flickitySelectNext = () => {
    var slider = $('.collection-slider-row .product-grid');
    slider.flickity('next');
}

toggleAccordionMenu = (e) => {
    var accordionContent = $(e).siblings('.jsc-menu-accordion-content');
    var plusIcon = $(e).find('.jsc-icon-plus');
    var minusIcon = $(e).find('.jsc-icon-minus');

    accordionContent.toggleClass('active');
    if(accordionContent.hasClass('active')) {
        plusIcon.hide()
        minusIcon.show();
    }
    else {
        plusIcon.show();
        minusIcon.hide();
    }

    var targetMenuItem = $(e).parent();
    var otherMenuItem = targetMenuItem.siblings('.jsc-menu-accordion-item');
    otherMenuItem.each(function(index, item) {
        var content = $(item).find('.jsc-menu-accordion-content');
        var plus = $(item).find('.jsc-icon-plus');
        var minus = $(item).find('.jsc-icon-minus');
        if(content.hasClass('active')) {
            content.removeClass('active');
            plus.show();
            minus.hide();
        }
    });
}

customGridAtc = (e) => {
    var vid = parseInt($(e).data('vid'));
    cartJsAtc(vid, 1, {});
}

toggleHeaderMenu = (e) => {
    var menuContent = $(e).siblings('.jsc-nav-item-content');
    menuContent.toggleClass('active');

    // $(e).toggleClass('active');

    // close other open accordion
    // var targetNavItem = $(e).parent();
    // var otherNavItem = targetNavItem.siblings('.jsc-mobile-nav-item');
    // otherNavItem.each(function(index, item) {
    //     var content = $(item).find('.jsc-nav-item-content');
    //     if(content.hasClass('active')) {
    //         content.removeClass('active')
    //     }
    //     var navTitle = $(item).find('.jsc-nav-item-title');
    //     if(navTitle.hasClass('active')) {
    //         navTitle.removeClass('active');
    //     }
    // });
}

toggleBackNavChild = (e) => {
    var parentContent = $(e).closest('.jsc-nav-item-content');
    parentContent.toggleClass('active');
    console.log('parentContent: ', parentContent);
}

initMobileNavSlider = () => {
    var mobileNav =  $('#pageheader .logo-area.container .jsc-mobile-slider-nav');
    $('#pageheader .logo-area.container .jsc-mobile-slider-nav .jsc-nav-slider').flickity({
        cellAlign: 'left',
        pageDots: false,
        prevNextButtons: false,
        adaptiveHeight: true,
        freeScroll: true,
        contain: true
    });
    mobileNav.css('visibility', 'visible');
}
triggerFilter = (e) => {
    $(e).toggleClass('active');
    if($(e).hasClass('active')) {
        var hideOos = $('.jsc-hide-oos');
        hideOos.click();
    }
    else {
        var showOos = $('.jsc-show-oos');
        showOos.click();
    }
}

checkUrlForFilter = () => {
    setInterval(() => {
        var url = window.location.href;
        var filterCheckbox = $('#jsc-availability-check');
        if(filterCheckbox.length) {
            if (url.includes("filter.v.availability=1")) {
                filterCheckbox.addClass('active');
            } else {
                filterCheckbox.removeClass('active');
            }
        }
    }, 1000);
}

togglePdpAccordion = (e) => {
    var $details = $(e).parent();
    var $productAccordion = $details.parents('.product-info-accordion');
    var $otherProdAccordion = $productAccordion.siblings('.product-info-accordion');

    $otherProdAccordion.each(function(index, item) {
        var $disclosure = $(item).find('.disclosure');
        if($disclosure.attr('open') === 'open') {
           $disclosure.removeAttr('open');
        }
    });
}

updateCharacterCount = (e) => {
    var characterCount = $(e).val().length;
    var $countText = $(e).parent().siblings('.jsc-cart-note-character').find('.jsc-note-character-count');
    $countText.text(characterCount);
}

onLoadUpdateCharacterCount = () => {
    var $cartNoteInput = $('cart-note textarea');
    var characterCount = $cartNoteInput.val().length;
    var $countText = $cartNoteInput.parent().siblings('.jsc-cart-note-character').find('.jsc-note-character-count');
    $countText.text(characterCount);
}


drawerUpsellGridHeight = () => {
    setInterval(() => {
        var $upsellGrid = $('.cart-item-upsells .product-grid--carousel')[0];
        var $productBlock = $($upsellGrid).find('.product-block');
        var maxHeight = 0;
        $productBlock.each(function(index, grid) {
            var $productTitle = $(grid).find('.product-block__title');
            var titleHeight = $productTitle.outerHeight(true);
            if (maxHeight < titleHeight) {
                maxHeight = titleHeight;
            }
        });
        $($productBlock).find('.product-block__title').css('height', maxHeight + 'px');
    }, 1000);
}

cartDrawerUpdate = () => {
    setTimeout(() => {
        jQuery.getJSON('/cart.js', function(cart) {
            var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
            drawerItemCount.text(cart.item_count);
            onloadToggleDonation();
            toggleUpsellBanner(cart);
        });
    }, 1000);
}

// start: cart upsell banner
toggleUpsellBanner = (cart) => {
    var upsellProdId = parseInt($('.jsc-product-upsell-banner').data('prod-id'));
    var cartItems = cart.items;
    var hideBanner = false;
    if(cartItems.length == 0)
    {
        hideBanner = true
    }
    else {
        $(cartItems).each(function(index, item) {
            var itemId = item.product_id;
            if(itemId === upsellProdId) { // upsell product already in the cart
                hideBanner = true;
            }
        });
    }

    if(hideBanner == true) {
        $('.jsc-product-upsell-banner').css('display', 'none');
    }
    else {
        $('.jsc-product-upsell-banner').css('display', 'flex');
        $('.jsc-product-upsell-banner').find('.jsc-upsell-variant-selector').css('display', 'none');
        $('.jsc-product-upsell-banner').find('.jsc-upsell-variant-selector > div').removeClass('active');
        $('.jsc-product-upsell-banner .jsc-upsell-product-info input').prop('checked', false);
    }
}

toggleUpsellVariantSelector = (e) => {
    var $variantSelector = $(e).parents('.jsc-upsell-product-info').find('.jsc-upsell-product-desc-container').find('.jsc-upsell-variant-selector');
    var isChecked = $(e).prop('checked');

    if(isChecked) {
        $variantSelector.css('display', 'flex');
    }
    else {
        $variantSelector.css('display', 'none');
    }
}

addSelectedEffect = (e) => {
    $(e).addClass('active');
    var $otherVariant = $(e).siblings();
    $otherVariant.removeClass('active');
}
// end: cart drawer upsell banner

openNewsletterPopup = () => {
    var $popupModal = $('pop-up.modal.popup-section');
    $popupModal.attr('open', '');
}

hideNewsletterTrigger = (e) => {
    sessionStorage.setItem('isHideTrigger', 'true');
    $(e).parent().hide();
}

onLoadCheckNewsletterTrigger = () => {
    var isHide = sessionStorage.getItem('isHideTrigger');
    if(isHide == 'true') {
        $('.jsc-newsletter-trigger').hide();
    }
}

// Start: GWP cart operation queue and checkout sync
var jscCartOperationQueue = Promise.resolve();
var jscGwpMergeSkips = 0;

jscQueueCartOperation = (operation) => {
    jscGwpMergeSkips++;
    jscCartOperationQueue = jscCartOperationQueue
        .then(function() {
            return new Promise(function(resolve, reject) {
                operation(resolve, reject);
            });
        })
        .catch(function() {})
        .finally(function() {});
    return jscCartOperationQueue;
}

jscWaitForCartIdle = () => {
    return jscCartOperationQueue.then(function() {
        return new Promise(function(resolve) {
            setTimeout(resolve, 300);
        });
    });
}

jscIsKnownGwpVariant = (variantId) => {
    var id = String(variantId);
    if ($('input[name="gwp-info"][gwp-vid="' + id + '"]').length > 0) return true;
    if ($('input[name="gwp-info"][tpb-gwp-vid="' + id + '"]').length > 0) return true;
    if ($('input[name="gwp-info"][collab-gwp-vid="' + id + '"]').length > 0) return true;
    if ($('input[name="gwp-info"][gift-vid="' + id + '"]').length > 0) return true;
    return false;
}

jscRunAllGwpSync = () => {
    gwpMinCartQty();
    colPurchaseGwp();
    minSpendGwp();
    collabMinSpendGwp();
    tierGwp();
}

jscGetCheckoutButtons = () => {
    return $('[name="checkout"], #update-cart[name="checkout"], .checkout-buttons a[href*="/checkout"]');
}

jscSetCheckoutLoading = (isLoading) => {
    var $btns = jscGetCheckoutButtons();
    if (isLoading) {
        $btns.addClass('jsc-checkout-loading').attr('aria-disabled', 'true');
    } else {
        $btns.removeClass('jsc-checkout-loading').removeAttr('aria-disabled');
    }
}

jscVerifyTierGwpState = (cart) => {
    var eligibleCartTotal = 0;
    $('.jsc-cart-item-tier-col').each(function() {
        var unitPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
        var quantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));
        eligibleCartTotal += unitPrice * quantity;
    });

    var expectedGwpInfo = {};
    $('.jsc-tier-gwp').each(function() {
        var gwpInventory = parseInt($(this).attr('gwp-inventory'));
        var minSpend = parseInt($(this).attr('min-spend'));
        var gwpId = parseInt($(this).attr('gwp-vid'));

        if (gwpInventory > 0 && eligibleCartTotal >= minSpend) {
            expectedGwpInfo[gwpId] = (expectedGwpInfo[gwpId] || 0) + 1;
        }
    });

    var tierGwpItemsInCart = {};
    cart.items.forEach(function(item) {
        if (item.properties && item.properties['_TierGwp'] === 'Free Gift') {
            tierGwpItemsInCart[item.id] = item.quantity;
        }
    });

    var expectedIds = Object.keys(expectedGwpInfo);
    for (var i = 0; i < expectedIds.length; i++) {
        var gwpId = parseInt(expectedIds[i]);
        var expectedQty = expectedGwpInfo[gwpId];
        if (!tierGwpItemsInCart[gwpId] || tierGwpItemsInCart[gwpId] !== expectedQty) {
            return false;
        }
    }

    var cartIds = Object.keys(tierGwpItemsInCart);
    for (var j = 0; j < cartIds.length; j++) {
        var cartGwpId = parseInt(cartIds[j]);
        if (!expectedGwpInfo[cartGwpId]) {
            return false;
        }
    }

    return true;
}

jscVerifyMinSpendGwpState = (cart) => {
    var $gwp = $('.jsc-min-spend-gwp');
    if ($gwp.length === 0) return true;

    var gwpInventory = parseInt($gwp.attr('gwp-inventory'));
    if (isNaN(gwpInventory) || gwpInventory <= 0) return true;

    var minSpend = parseInt($gwp.attr('min-spend'));
    var appliedEach = $gwp.attr('gwp-applied-each');
    var maxGwpQty = parseInt($gwp.attr('max-gwp-qty'));
    var finalTotal = 0;

    $('.jsc-cart-item-minSpendCol').each(function() {
        var itemOriginalPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
        var itemQuantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));
        finalTotal += itemOriginalPrice * itemQuantity;
    });

    var giftQty = 1;
    if ((appliedEach === 'true' || appliedEach === true) && finalTotal >= minSpend) {
        giftQty = Math.floor(finalTotal / minSpend);
        if (maxGwpQty > 0 && giftQty > maxGwpQty) {
            giftQty = maxGwpQty;
        }
        if (giftQty > gwpInventory) {
            giftQty = gwpInventory;
        }
    }

    var inCartQty = 0;
    var isGiftInCart = false;
    cart.items.forEach(function(item) {
        if (item.properties && item.properties['_MinSpendGwp'] === 'Free Gift') {
            isGiftInCart = true;
            inCartQty = item.quantity;
        }
    });

    if (finalTotal >= minSpend) {
        return isGiftInCart && inCartQty === giftQty;
    }
    return !isGiftInCart;
}

jscVerifyColPurchaseGwpState = (cart) => {
    var $gwp = $('.jsc-col-purchase-gwp');
    if ($gwp.length === 0) return true;

    var gwpInventory = parseInt($gwp.attr('gwp-inventory'));
    if (isNaN(gwpInventory) || gwpInventory <= 0) return true;

    var hasQualifyingItems = $('.jsc-cart-item-colPurchase').length > 0;
    var inCartQty = 0;
    var isGiftInCart = false;

    cart.items.forEach(function(item) {
        if (item.properties && item.properties['_ColPurchaseGwp'] === 'Free Gift') {
            isGiftInCart = true;
            inCartQty = item.quantity;
        }
    });

    if (hasQualifyingItems) {
        return isGiftInCart && inCartQty === 1;
    }
    return !isGiftInCart;
}

jscVerifyCollabMinSpendGwpState = (cart) => {
    var isValid = true;

    $('.jsc-min-spend-collab-gwp').each(function(index, gwpEl) {
        var newIndex = index + 1;
        var tpbGwpAvailable = $(gwpEl).attr('tpb-gwp-available');
        var collabGwpAvailable = $(gwpEl).attr('collab-gwp-available');
        var minSpend = parseInt($(gwpEl).attr('min-spend'));
        var tpbItemTotal = 0;
        var collabItemTotal = 0;
        var cartTotal = 0;
        var isTpbGwpInCart = false;
        var tpbGwpInCartQty = 0;
        var isCollabGwpInCart = false;
        var collabGwpInCartQty = 0;
        var expectTpbInCart = false;
        var expectCollabInCart = false;

        $(`.jsc-cart-item-collab-gwp-${newIndex}`).each(function() {
            var itemOriginalPrice = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-price'));
            var itemQuantity = parseInt($(this).find('.cart-item__not-image').find('.cart-item__price.jsc-cart-item-price').attr('data-item-qty'));
            itemOriginalPrice = itemOriginalPrice * itemQuantity;
            cartTotal += itemOriginalPrice;

            if ($(this).hasClass(`jsc-cart-item-tpb-min-spend-${newIndex}`)) {
                tpbItemTotal += itemOriginalPrice;
            }
            if ($(this).hasClass(`jsc-cart-item-collab-min-spend-${newIndex}`)) {
                collabItemTotal += itemOriginalPrice;
            }
        });

        cart.items.forEach(function(item) {
            var itemProperties = item.properties;
            if (itemProperties && itemProperties['_CollabMinSpendGwp'] === 'TPB Gift') {
                isTpbGwpInCart = true;
                tpbGwpInCartQty = item.quantity;
            }
            if (itemProperties && itemProperties['_CollabMinSpendGwp'] === 'Collab Gift') {
                isCollabGwpInCart = true;
                collabGwpInCartQty = item.quantity;
            }
        });

        if (tpbGwpAvailable == 'true' || collabGwpAvailable == 'true') {
            if (cartTotal >= minSpend) {
                if (collabItemTotal > 0) {
                    if (collabGwpAvailable == 'true') {
                        expectCollabInCart = true;
                    } else if (tpbItemTotal >= minSpend && tpbGwpAvailable == 'true') {
                        expectTpbInCart = true;
                    }
                } else if (tpbGwpAvailable == 'true') {
                    expectTpbInCart = true;
                }
            }
        }

        if (expectTpbInCart !== isTpbGwpInCart || expectCollabInCart !== isCollabGwpInCart) {
            isValid = false;
            return false;
        }
        if (expectTpbInCart && tpbGwpInCartQty !== 1) {
            isValid = false;
            return false;
        }
        if (expectCollabInCart && collabGwpInCartQty !== 1) {
            isValid = false;
            return false;
        }
    });

    return isValid;
}

jscVerifyGwpMinCartQtyState = (cart) => {
    var isValid = true;

    $('.jsc-gwp-min-cart-qty').each(function(index, gwpEl) {
        var newIndex = index + 1;
        var accumulateQty = 0;
        var purchaseQty = parseInt($(gwpEl).attr('purchaseQty'));
        var giftInventory = parseInt($(gwpEl).attr('gift-inventory'));
        var giftHandle = $(gwpEl).attr('gift-handle');

        if (isNaN(giftInventory) || giftInventory <= 0) {
            return true;
        }

        $(`.jsc-cart-item-qtycol-${newIndex}`).each(function() {
            var itemQty = parseInt($(this).find('.cart-item__not-image').find('.cart-item__quantity .quantity .cart-item__quantity-input').attr('data-initial-value'));
            if (!isNaN(itemQty)) {
                accumulateQty += itemQty;
            }
        });

        var expectedGiftQty = Math.floor(accumulateQty / purchaseQty);
        if (expectedGiftQty > giftInventory) {
            expectedGiftQty = giftInventory;
        }

        var inCartQty = 0;
        var isGiftInCart = false;
        cart.items.forEach(function(item) {
            if (item.handle === giftHandle && item.properties && item.properties['_Promo'] === 'Free Gift') {
                isGiftInCart = true;
                inCartQty = item.quantity;
            }
        });

        if (expectedGiftQty > 0) {
            if (!isGiftInCart || inCartQty !== expectedGiftQty) {
                isValid = false;
                return false;
            }
        } else if (isGiftInCart) {
            isValid = false;
            return false;
        }
    });

    return isValid;
}

jscVerifyGwpCartState = () => {
    return fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
            return jscVerifyTierGwpState(cart)
                && jscVerifyMinSpendGwpState(cart)
                && jscVerifyColPurchaseGwpState(cart)
                && jscVerifyCollabMinSpendGwpState(cart)
                && jscVerifyGwpMinCartQtyState(cart);
        })
        .catch(function() { return false; });
}

jscEnsureGwpSynced = (maxAttempts) => {
    maxAttempts = maxAttempts || 5;
    var attempt = 0;

    function trySync() {
        jscRunAllGwpSync();
        return jscWaitForCartIdle()
            .then(function() {
                return new Promise(function(resolve) {
                    setTimeout(resolve, 500);
                });
            })
            .then(jscWaitForCartIdle)
            .then(jscVerifyGwpCartState)
            .then(function(isValid) {
                if (isValid) return true;
                attempt++;
                if (attempt >= maxAttempts) return false;
                return trySync();
            });
    }

    return trySync();
}
// End: GWP cart operation queue and checkout sync

cartJsAtc = (vid, qty, obj) => {
    return jscQueueCartOperation(function(resolve, reject) {
        CartJS.addItem(vid, qty, obj, {

            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);
                    onloadToggleDonation();
                    toggleUpsellBanner(cart);
                });

                if(window.location.href.includes('/cart')) {
                    location.reload();
                }
                else {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer
                }
                resolve(data);
            },

            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                $('#message').addClass('message-error');
                $('#message').html('There was a problem adding to the cart!');
                reject(errorThrown);
            }
        });
    });
}

cartJsUpdate = (vid, qty, obj) => {
    // Cart js add item, success callback, error callback
    return jscQueueCartOperation(function(resolve, reject) {
        CartJS.updateItemById(vid, qty, obj, {

            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); // open cart drawer

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);

                    toggleUpsellBanner(cart);
                });

                if(window.location.href.includes('/cart')) {
                    location.reload();
                }
                resolve(data);
            },

            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                $('#message').addClass('message-error');
                $('#message').html('There was a problem adding to the cart!');
                reject(errorThrown);
            }
        });
    });
}

// start: grid variant selector
showGridVariantSelector = (e) => {
    var $gridVariantSelector = $(e).siblings('.jsc-grid-variant-selector');
    
    // show variant selector and hide ATC button
    $gridVariantSelector.show();
    checkVariantAvailability(e);
    $(e).hide();

    // hide the variant selector and show ATC button again when cursor leave the selector
    $($gridVariantSelector).on('mouseleave', function() {
        $(this).hide();
        $(e).show();
    });
}
customVariantGridAtc = (e) => {
    var variantDataInput = $(e).parent().siblings("input[name='jsc-all-product-variants']");
    var variantsData = JSON.parse($(variantDataInput).val());
    var option1Name = $(e).data('option').toString();
    var vid = 0;
    for(var variant of variantsData) {
        if (variant.option1 === option1Name) {
            vid = parseInt(variant.id);
            break;
        }
    }
    cartJsAtc(vid, 1, {});
}
checkVariantAvailability = (e) => {
    var variantDataInput = $(e).siblings('.jsc-grid-variant-selector').find("input[name='jsc-all-product-variants']");
    var variantsData = JSON.parse($(variantDataInput).val());
    for(var variant of variantsData) {
        if (variant.available == false) {
            var option1Name = variant.option1;
            var liOption = variantDataInput.siblings('.jsc-variants').find('[data-option="' + option1Name + '"]');
            liOption.addClass('is-oos');
            liOption.removeAttr('onclick');
        }
    }
}
// end: grid variant selector

// mobile collection page promo grid height
setMobilePromoGridHeight = () => {
    if($(window).width() < 481) {
        var $productGrid = $('.product-grid');
        var $promoBanner = $($productGrid).find('.jsc-grid-promo-banner');
        if($promoBanner.length > 0) {
            $($promoBanner).each(function(index, banner) {
                var $nearestSibling = $(banner).nextAll('.product-block:first');
                var bannerHeight = $nearestSibling.height() - 30;
                $(banner).css('height', bannerHeight + 'px');
                console.log(bannerHeight);
            });
        }
    }
}

// start: close announcement bar
closeAnnouncementBar = (e) => {
    sessionStorage.setItem('isCloseAnnouncement', 'true');
    $(e).parents('.announcement-bar').hide();
    $(e).parents('.section-announcement-bar').addClass('is-hidden').hide();
    const pageHeader = document.querySelector('page-header');
    if (pageHeader) {
        pageHeader.setHeaderHeightProperty();
        pageHeader.setTransparency();
    }
}
onLoadCheckAnnouncementBar = () => {
    var isClose = sessionStorage.getItem('isCloseAnnouncement');
    if(isClose == 'true') {
        $('.announcement-bar').hide();
        $('.section-announcement-bar').addClass('is-hidden').hide();
        const pageHeader = document.querySelector('page-header');
        if (pageHeader) {
            pageHeader.setHeaderHeightProperty();
        }
    }
}
// end: close announcement bar

initYmalSlider = () => {
    setTimeout(() => {
        var ymalGrid = $('.related-collection .product-grid');
        console.log(ymalGrid);
        if($(window).width() < 481) {
            $('.related-collection .product-grid').flickity({
                cellAlign: 'left',
                pageDots: false,
                prevNextButtons: false,
                adaptiveHeight: true,
                freeScroll: true,
                contain: true
            });
        }
    }, 1000);
}

mobileAccountOrderColSpan = () => {
    var $orderSummaryLabel = $('.order-table-container #order_details tfoot .order_summary .label');
    if($orderSummaryLabel.length > 0 && $(window).width() <= 480) {
        $orderSummaryLabel.attr('colspan', 2);
    }
}

// start: store selector
openStorePopup = (e) => {
    var $modal = $(e).siblings('.jsc-store-selector-modal');
    var $overlay = $('.overlay.js-overlay');

    $modal.addClass('active');
    $overlay.addClass('is-visible');
}

closeStorePopup = (e) => {
   var $modal = $(e).parents('.jsc-store-selector-modal');
   var $overlay = $('.overlay.js-overlay');

   $modal.removeClass('active');
   $overlay.removeClass('is-visible');
}

toggleSelector = (e) => {
    $(e).toggleClass('active');
}

updateStoreSelectorText = () => {
    var $modal = $('.jsc-store-selector-modal');
    var $selector = $($modal).find('.jsc-custom-selector');
    var $selectedText = $($selector).find('.jsc-custom-selector__selected-text');
    var $options = $($selector).find('.jsc-custom-selector__options li');
    var $submitBtn = $($modal).find('.jsc-store-selector-submit-btn');
    var currentUrl = window.location.href;

    $options.each(function() {
        $(this).on('click', function() {
            var optionText = $(this).text();
            var url = $(this).attr('data-url');

            $selectedText.text(optionText);
            if(currentUrl.startsWith(url)) {
                $submitBtn.attr('href', '#');
                $submitBtn.attr('target', '_self');
            }
            else {
                $submitBtn.attr('href', url);
            }
        });
    });
}
// end: store selector
// start: mega menu max-width
setMegamenuWidth = () => {
    var width = $('.pageheader--layout-inline-menu-center .logo-area__left').width();
    console.log('proxy-nav width:', width);
    console.log('NavigationTier2-: ', $('.navigation__tier-2-container .container'))
    $('.navigation__tier-2-container .container').css('max-width', `${width}px`);
}
$(window).resize(function() {
    setMegamenuWidth();
    disableGalleryViewerForMixMatch();
})
// end: megamenu max-width

// start: custom bundle
onclickBundleChgeVariant  = (evt,$variantTitle) => {
    var $this = $(evt);
    $this.parent().find('.opt-label').removeClass('active')
    $this.addClass('active');

    //Reset selected vid 
    var $findSelectedColor = $this.closest('.jsc-bundle-wrapper').find('.jsc-swatch-opt-list').find('.jsc-swatch-opt-wrapper').find('.jsc-swatch-opt.active');
    var $variantListHidden = $findSelectedColor.parent().find('.visually-hidden').find('._jsc-var');
    $variantListHidden.each(function() {
        var variantTitle = $(this).attr('variant-title');
        var variantId = $(this).attr('variant-id');
        
        if ($variantTitle == variantTitle) {
            $(this).closest('.jsc-swatch-opt-wrapper').find('.jsc-swatch-opt.active').attr('data-vid',variantId); 
        }
    });
}

onclickBundleChgeSwatch = (evt) => {
    var $this = $(evt);
    // Remove active from all swatches in the same bundle wrapper (including all material categories)
    $this.closest('.jsc-bundle-wrapper').find('.jsc-swatch-opt').removeClass('active')
    $this.addClass('active');

    // Clear error message when swatch is selected
    $this.closest('.jsc-bundle-wrapper').find('.bundle-swatch-error').hide().text('');

    //change featured image
    var $image = $this.attr('featured-image');
    $this.closest('.jsc-bundle-wrapper').find('.bundle-preview-img img').attr('src',$image);

    // Only update title for custom bundle, not for mix match
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        var $title = $this.attr('product-title');
        $this.closest('.bundle-swatch-list').find('.bundle-preview-product-title').text($title);
    }

    var $swatch = $this.attr('swatch');
    $this.closest('.bundle-swatch-list').find('.swatch').text($swatch);

    // Update swatch name in the material category (only for mix match)
    if ($('.jsc-mix-match-media-gallery').length > 0) {
        // Clear all swatch names first
        $this.closest('.jsc-material-category-swatch').find('.jsc-swatch-name').text('');
        
        // Find the jsc-swatch-opt-list that contains this swatch
        var $swatchOptList = $this.closest('.jsc-swatch-opt-list');
        // Find the previous sibling jsc-material-category (the one this swatch belongs to)
        var $materialCategoryForSwatch = $swatchOptList.prev('.jsc-material-category');
        if ($materialCategoryForSwatch.length > 0) {
            $materialCategoryForSwatch.find('.jsc-swatch-name').text($swatch);
        }
    }

    // Update swatch description
    var $swatchDescription = $this.attr('data-swatch-description');
    
    // For mix match bundles
    if ($('.jsc-mix-match-media-gallery').length > 0) {
        // Check if this is a material category swatch
        var $swatchOptList = $this.closest('.jsc-swatch-opt-list');
        var $materialCategoryForSwatch = $swatchOptList.prev('.jsc-material-category');
        
        if ($materialCategoryForSwatch.length > 0) {
            // For mix match with material categories, show description below the material category
            // Clear all descriptions first
            $this.closest('.jsc-material-category-swatch').find('.jsc-material-category .bundle-swatch-description').hide().html('');
            
            var $descriptionElement = $materialCategoryForSwatch.find('.bundle-swatch-description');
            if ($swatchDescription && $swatchDescription !== '') {
                $descriptionElement.html($swatchDescription).show();
            } else {
                $descriptionElement.hide().html('');
            }
        } else {
            // For mix match without material categories, show description after swatch
            var $bundleSwatchList = $this.closest('.bundle-swatch-list');
            var $swatchElement = $bundleSwatchList.find('.swatch');
            var $descriptionElement = $bundleSwatchList.find('.bundle-swatch-description');
            
            if ($swatchDescription && $swatchDescription !== '') {
                if ($descriptionElement.length === 0) {
                    $descriptionElement = $('<div class="bundle-swatch-description" style="font-style: italic;"></div>');
                    $swatchElement.after($descriptionElement);
                }
                $descriptionElement.html($swatchDescription).show();
            } else {
                $descriptionElement.hide().html('');
            }
        }
    } else {
        // For custom bundle (no material categories), show description after swatch
        var $swatchElement = $this.closest('.bundle-swatch-list').find('.swatch');
        var $descriptionElement = $this.closest('.bundle-swatch-list').find('.bundle-swatch-description');
        
        if ($swatchDescription && $swatchDescription !== '') {
            if ($descriptionElement.length === 0) {
                $descriptionElement = $('<div class="bundle-swatch-description" style="font-style: italic;"></div>');
                $swatchElement.after($descriptionElement);
            }
            $descriptionElement.html($swatchDescription).show();
        } else {
            $descriptionElement.hide().html('');
        }
    }

    // Reset variant list - set first active option, available or oos 
    $this.closest('.bundle-swatch-list').find('.variant-picker').find('.jsc-opt-label-list').removeClass('active');
    $this.closest('.bundle-swatch-list').find('.variant-picker').find('.jsc-opt-label-list').removeClass('disabled');

    var $selected_vid = $this.parent('.jsc-swatch-opt-wrapper').find('.visually-hidden').find('.first-active-found').attr('variant-id');
    $this.attr('data-vid',$selected_vid);

    var $variantOptionList = $this.closest('.bundle-swatch-list').find('.variant-picker').find('.opt-label');
    $variantOptionList.each(function() {
        var $label = $(this);
        $label.removeAttr('disabled',true);
        var labelText = $.trim($label.find('span').text()); 

        var matchFound = false;
        var $variantListHidden = $this.closest('.bundle-swatch-list').find('.jsc-swatch-opt-list').find('.jsc-swatch-opt-wrapper').find('._jsc-var');
            $variantListHidden.each(function() {
                var variantTitle = $(this).attr('variant-title');
                
                if ($(this).hasClass('first-active-found') && labelText === variantTitle) {
                    $label.addClass('active'); 
                }

                if (labelText == variantTitle) {
                    matchFound = true; 
                    return false;
                }
            });
        
            if (!matchFound) {
                $label.addClass('disabled');
            }
    });

    // Reset url
    var $url = $this.attr('data-vurl');
    $this.closest('.jsc-bundle-wrapper').find('.bundle-preview-product-url').attr('href',$url);
    updateMixMatchOverlayImages();
    
    // Scroll to and click base image thumbnail
    scrollToAndClickBaseImageThumbnail();
}

bundleAtc = (e,title,fvid,bundleitem) => {
    console.log('bundleAtc');
    var $this = $(e);
    var $jsonObj = [];
    var totalBundleItems = parseInt(bundleitem);

    var $cur_Date = new Date();
    var $date_time = $cur_Date.getDate() + "/"
                + ($cur_Date.getMonth()+1)  + "/"
                + $cur_Date.getFullYear() + ","
                + $cur_Date.getHours() + ":"
                + $cur_Date.getMinutes() + ":"
                + $cur_Date.getSeconds() + ":"
                + $cur_Date.getMilliseconds();
    var $bunldeId = fvid + '-' + $date_time; 

    //close bundle popup 
    if ($this.closest('.jsc-custom-bundle-modal').length) {
        $this.closest('.jsc-custom-bundle-modal').removeAttr('open');
      }

    // Validate bundle selections
    var $bundleWrappers = $this.closest('.jsc-custom-bundle').find('.jsc-bundle-wrapper');
    var hasErrors = false;
    var firstErrorElement = null;
    
    // Clear previous errors
    $bundleWrappers.find('.bundle-swatch-error').hide().text('');
    
    $bundleWrappers.each(function() {
        var $wrapper = $(this);
        var $swatchList = $wrapper.find('.jsc-swatch-opt-list, .jsc-swatch-list');
        var $activeSwatch = $swatchList.find('.jsc-swatch-opt.active:not(.addon-swatch)');
        var $productTitle = $wrapper.find('.bundle-preview-product-title').text().trim();
        // Error container is now a sibling of bundle-swatch-list, not a child
        var $errorContainer = $wrapper.find('.bundle-swatch-error');
        
        if ($activeSwatch.length === 0) {
            hasErrors = true;
            // Get error message from collection metafield, fallback to default
            var errorMessage = $errorContainer.attr('data-error-message');
            var errorText = errorMessage && errorMessage !== '' ? errorMessage : ('Please ' + $productTitle);
            if ($errorContainer.length > 0) {
                $errorContainer.text(errorText).css('display', 'block');
                console.log('Showing error for bundle:', errorText);
            } else {
                console.error('Error container not found for bundle:', $productTitle, 'Wrapper:', $wrapper);
            }
            
            if (firstErrorElement === null && $errorContainer.length > 0) {
                firstErrorElement = $errorContainer[0];
            }
        }
    });
    
    // If there are errors, scroll to first error and return
    if (hasErrors) {
        console.log('Has errors, preventing add to cart');
        if (firstErrorElement) {
            var $errorEl = $(firstErrorElement);
            var elementTop = $errorEl.offset().top;
            var windowHeight = $(window).height();
            var elementHeight = $errorEl.outerHeight();
            // Center the error element on screen
            var scrollTo = elementTop - (windowHeight / 2) + (elementHeight / 2);
            $('html, body').animate({
                scrollTop: scrollTo
            }, 500);
        }
        return false;
    }

          // Validate addon selections
    var $addonOptions = $this.closest('.jsc-custom-bundle').find('.addon-checkbox-input:checked').toArray();
    
    // Clear previous addon errors
    $this.closest('.jsc-custom-bundle').find('.addon-swatch-error').hide().text('');
    
    $($addonOptions).each(function() {
        var $checkbox = $(this);
        var $addonCollectionId = $checkbox.attr('data-collection-id');
        var $addonItem = $checkbox.closest('.addon-item');
        var $addonSwatch = $this.closest('.jsc-custom-bundle').find('#addon-swatches-' + $addonCollectionId + ' .active.addon-swatch');
        var $addonTitle = $addonItem.find('.addon-title-price h5').first().text().trim();
        var $errorContainer = $addonItem.find('.addon-swatch-error');
        
        if ($addonSwatch.length === 0) {
            hasErrors = true;
            // Get error message from collection metafield, fallback to default
            var errorMessage = $errorContainer.attr('data-error-message');
            var errorText = errorMessage && errorMessage !== '' ? errorMessage : ('Please select your ' + $addonTitle);
            if ($errorContainer.length > 0) {
                $errorContainer.text(errorText).css('display', 'block');
                console.log('Showing error for addon:', errorText);
            } else {
                console.error('Error container not found for addon:', $addonTitle, 'Addon item:', $addonItem);
            }
            
            if (firstErrorElement === null && $errorContainer.length > 0) {
                firstErrorElement = $errorContainer[0];
            }
        }
    });
    
    // If there are addon errors, scroll to first error and return
    if (hasErrors) {
        if (firstErrorElement) {
            var $errorEl = $(firstErrorElement);
            var elementTop = $errorEl.offset().top;
            var windowHeight = $(window).height();
            var elementHeight = $errorEl.outerHeight();
            // Center the error element on screen
            var scrollTo = elementTop - (windowHeight / 2) + (elementHeight / 2);
            $('html, body').animate({
                scrollTop: scrollTo
            }, 500);
        }
        return false;
    }
    
    // Addon products
    $($addonOptions).each(function() {
        var $addonProd = {};
        var $addonProp = {};
        var $addonCollectionId = $(this).attr('data-collection-id');
        var $addonSwatch = $this.closest('.jsc-custom-bundle').find('#addon-swatches-' + $addonCollectionId + ' .active.addon-swatch');
        
        if ($addonSwatch.length > 0) {
            var $addonVid = $addonSwatch.attr('data-vid');
            
            $addonProd['id'] = $addonVid;
            $addonProd['quantity'] = 1;
            
            if ($('.jsc-mix-match-media-gallery').length > 0) {
                $addonProp['_MainMixMatchIs'] = title;
                $addonProp['_AddonMixMatch'] = true;
            }else{
                $addonProp['_MainBundleIs'] = title;
                $addonProp['_AddonBundle'] = true;
            }
            
            $addonProp['_BindID'] = $bunldeId;
            
            $addonProd['properties'] = $addonProp;
            $jsonObj.push($addonProd);
        }
    });

    var $swatchOptions =  $this.closest('.jsc-custom-bundle').find('.active.jsc-swatch-opt:not(.addon-swatch)').toArray().reverse();

    $($swatchOptions).each(function() {
        var $bundleProd = {};
        var $bundleProp = {};   
        var $bundleVid = $(this).attr('data-vid');

        $bundleProd['id'] = $bundleVid;
        $bundleProd['quantity'] = 1;

        $bundleProp['_MainBundleIs'] = title;
        
        if ($('.jsc-mix-match-media-gallery').length > 0) {
            $bundleProp['_MixMatch'] = true;
        }else{
            $bundleProp['_Bundle'] = true;
        }
        // $bundleProp['_TotalBundleItems'] = totalBundleItems;
        // $bundleProp['_Off-Value'] = discount;
        // $bundleProp['_Quantity-Promo'] = 'percentage-off-bundle';
        $bundleProp['_BindID'] = $bunldeId;
        // $bundleProp['_DummyProduct'] = ftitle;
        // $bundleProp['_DummyProductUrl'] = furl;
        // $bundleProp['_DummyProductImg'] = fimage;

        $bundleProd['properties'] = $bundleProp;
        $jsonObj.push($bundleProd);
    });


    // Main Bundle product obj
    var $mainProd = {};
    var $mainProp = {};
    $mainProd['id'] = fvid;
    $mainProd['quantity'] = 1;
    
    if ($('.jsc-mix-match-media-gallery').length > 0) {
        $mainProp['_MainMixMatch'] = 'Yes';
    }else{
        $mainProp['_MainBundle'] = 'Yes';
    }

    $mainProp['_BindID'] = $bunldeId;
    $mainProp['_TotalBundleItems'] = totalBundleItems;
    $mainProd['properties'] = $mainProp;
    $jsonObj.push($mainProd);

    CartJS.addItems($jsonObj,{
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                console.log('success');
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                    bubbles: true
                }));

                $(document).on('cart.requestComplete', function(event, cart) {
                    var cartCount = $('.cart-link__count');
                    cartCount.text(cart.item_count);

                    var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
                    drawerItemCount.text(cart.item_count);
                    onloadToggleDonation();
                    toggleUpsellBanner(cart);
                });

                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); 
                    
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown);
            }
    });

}

removeBundleSet = (keylist) => {
    var $keysplit = keylist.split(",");
    var $jsonObj = {};
    for (i=0;i<$keysplit.length;i++){
        $jsonObj[$keysplit[i]] = 0;
    }
  
    CartJS.updateItemQuantitiesById($jsonObj,{
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
                $(document).on('cart.requestComplete', function(event, cart) {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                        bubbles: true
                    }));
                    toggleUpsellBanner(cart);
                });       
            },
            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log("Error occur !", errorThrown);
            }
    });
};

removeIncompleteBundleSet = () => {
    $.getJSON('/cart.js', function(cart) {
        var _cartItems = cart.items;
        var $jsonObj = {};
        
        for (var i = 0; i < _cartItems.length; i++) {
          var _itemsKey = _cartItems[i].key;
          var _itemsBindID = _cartItems[i].properties['_BindID'];
      
          $('.jsc-bundle-item').each(function(){
            var $this = $(this);
            var $totalItem = $this.attr('data-total-item');
            var $thisSetBindID = $this.attr('data-bindid');
            var $eachItem = $this.find('.jsc-individual-bundle-item');
            var $countTotalItem_cartpage = 0;
        
            $eachItem.each(function(){
              $countTotalItem_cartpage += 1;
            });

            if ($totalItem != '') {
              if ($countTotalItem_cartpage != $totalItem) {          
                
                if (_itemsBindID == $thisSetBindID) {                
                  $jsonObj[_itemsKey] = 0;
                }
              }
            }
          });
          
        }

        if (Object.keys($jsonObj).length > 0) {
            $('#modal-pop_up_bundleoo').css('display','flex');
            CartJS.updateItemQuantitiesById($jsonObj);

        }
    }); 
}


closeBundleOOSPopup = () => {
    $('#modal-pop_up_bundleoo').hide();

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
    }));

    $.getJSON('/cart.js', function(cart) {
        var cartCount = $('.cart-link__count');
        cartCount.text(cart.item_count);
    
        var drawerItemCount = $('.jsc-drawer-item-count .jsc-item-count');
        drawerItemCount.text(cart.item_count);
        
        onloadToggleDonation();
        toggleUpsellBanner(cart);
    });
};

// end: custom bundle

// start: sticky ATC
moveStickyATC = () => {
  var $pdpStickyATC = $('.jsc-sticky-add-to-cart-container[pdp]');
  var $themeStickyATC = $('.jsc-sticky-add-to-cart-container[theme]');

  if ($pdpStickyATC.length > 0) {
      $themeStickyATC.html($pdpStickyATC.html());
      $pdpStickyATC.remove();
  }
}

triggerSubmitBtn = (evt) => {
  var available = $(evt).attr('data-available');
  var $pdpATCBtn = $('product-form buy-buttons.main-prod-buy-buttons-row button.add-to-cart');
  var $pdpBisBtn = $('product-form buy-buttons.main-prod-buy-buttons-row button.swym-add-to-watchlist');

  // Fallback: if specific selector doesn't find the element, try simpler selector
  if ($pdpBisBtn.length === 0) {
    $pdpBisBtn = $('.swym-add-to-watchlist');
  }
  
  if (available == 'true') {
      $pdpATCBtn.click();
  }
  else {
      $pdpBisBtn.click();
  }

  if ($pdpATCBtn.hasClass('cursor-arrow')) {
    // anchor to variant picker
    var $variantPicker = $('variant-picker');
    if ($variantPicker.length > 0) {
      var rect = $variantPicker[0].getBoundingClientRect();
      var isVisible = (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );
      if (!isVisible) {
        // Scroll variant picker into view
        $variantPicker[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    }
  }
}

updateStickyATCInfo = (variant) => {
  var $themeStickyATC = $('.jsc-sticky-add-to-cart-container[theme]');
  if ($themeStickyATC.length > 0) {
      var available = variant.available;
      var price = variant.price;
      var $stickyATCBtn = $themeStickyATC.find('.jsc-sticky-atc-btn');
      var optionNameList = $stickyATCBtn.attr('data-options').split(',');
      var $stickyATCPrice = $themeStickyATC.find('.jsc-sticky-product-price');
      var moneyFormat = $stickyATCPrice.attr('money-format');
      var currency = $stickyATCPrice.attr('currency');
      var formattedPrice = formatMoney(price, moneyFormat, currency);

      var variantName = '';
      for (var i = 1; i <= optionNameList.length; i++) {
        var optionIndexName = 'option' + i;
        variantName += optionNameList[i - 1] + ' ' + variant[optionIndexName];
        
        if (i < optionNameList.length) {
          variantName += ', ';
        }
      }

      $stickyATCBtn.attr('data-available', available);
      if (available) {
        var isPreorder = $themeStickyATC.attr('data-is-preorder') === 'true';
        if (isPreorder) {
          $stickyATCBtn.text('PRE-ORDER NOW');
        } else {
          $stickyATCBtn.text(`ADD TO CART (${variantName.replace('Denominations ', '').replace('Denominations', '')})`);
        }
      }
      else {
          $stickyATCBtn.text('NOTIFY ME');
      }

      $stickyATCPrice.text(formattedPrice);
  }

  
}

formatMoney = (cents, format, currency) => {
const noDecimals = ['JPY', 'KRW'];
const isZeroDecimal = noDecimals.includes(currency);

let value = isZeroDecimal
  ? Math.round(cents).toLocaleString('en-US') // for JPY: 176000 → "176,000"
  : (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

let valueNoDecimals = Math.round(cents / 100).toLocaleString('en-US');

let valueWithCommaSeparator = (cents / 100).toLocaleString('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

let valueWithCommaSeparatorNoDecimals = Math.round(cents / 100).toLocaleString('de-DE');

return format
  .replace('{{amount}}', value)
  .replace('{{amount_no_decimals}}', valueNoDecimals)
  .replace('{{amount_with_currency}}', value)
  .replace('{{amount_no_decimals_with_currency}}', valueNoDecimals)
  .replace('{{amount_with_comma_separator}}', valueWithCommaSeparator)
  .replace('{{amount_with_comma_separator_with_currency}}', valueWithCommaSeparator)
  .replace('{{amount_no_decimals_with_comma_separator}}', valueWithCommaSeparatorNoDecimals)
  .replace('{{amount_no_decimals_with_comma_separator_with_currency}}', valueWithCommaSeparatorNoDecimals);
}

showVariantError = (event, el) => {
  if ($(el).hasClass('cursor-arrow')) {
    event.preventDefault();
    var $optionError = $('.option-selector__error');
    $optionError.removeClass('d-none');
  }
}
// end: sticky ATC

// start: pdp dynamic shipping table
updateShippingContent = () => {
  var $pdpAccordion = $('.product-form').find('.product-info-accordion[is-shipping-table]');
  if ($pdpAccordion.length > 0) {
    $pdpAccordion.each(function() {
      var currentCountry = $(this).attr('current-country');
      var $content = $(this).find('.disclosure__content');
      var $countryEl = $content.find('[country]');
      var $spacingEl = $content.find('p:not([country])');

      $spacingEl.hide();
      var matchIndex = 0;
      $countryEl.each(function(index, $el) {
        var countryAttr = $($el).attr('country');
        var countries = countryAttr.split(',').map(c => c.trim());
        var shouldShow = countries.includes(currentCountry);

        if (shouldShow) {
          matchIndex ++;
          if (matchIndex > 1) {
            $($el).show();
          }
          else {
            $($el).hide();
          }
        } else {
          $($el).hide();
        }
      });
    });
  }
}
// end: pdp dynamic shipping table


// start: Mix Match & Addon Functionality
// Helper function to find base image slider item by alt text
findMixMatchBaseImage = ($mediaGallery, isMobile) => {
    var $baseImageSliderItem = null;
    
    // Search in main carousel slider items
    $mediaGallery.find('.slider__item').each(function() {
        var $item = $(this);
        var $img = $item.find('img');
        var altText = $img.attr('alt') || $item.find('.product-media__label-text').text() || '';
        var altTextLower = altText.toLowerCase();
        
        var isMatch = false;
        if (isMobile) {
            // Mobile: must include "mobile-mixmatch-base"
            isMatch = altTextLower.includes('mobile-mixmatch-base');
        } else {
            // Desktop: must include "desktop-mixmatch-base"
            isMatch = altTextLower.includes('desktop-mixmatch-base');
        }
        
        if (isMatch) {
            $baseImageSliderItem = $item;
            return false; // Break the loop
        }
    });
    
    // If not found in main carousel, try desktop collage
    if ($baseImageSliderItem === null || $baseImageSliderItem.length === 0) {
        $mediaGallery.find('.product-media-collage__item').each(function() {
            var $item = $(this);
            var $img = $item.find('img');
            var altText = $img.attr('alt') || $item.find('.product-media__label-text').text() || '';
            var altTextLower = altText.toLowerCase();
            
            // Desktop collage: must include "desktop-mixmatch-base"
            if (altTextLower.includes('desktop-mixmatch-base')) {
                $baseImageSliderItem = $item;
                return false; // Break the loop
            }
        });
    }
    
    return $baseImageSliderItem;
}

updateMixMatchOverlayImages = () => {
    // Only apply if jsc-mix-match-media-gallery exists on page
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        return;
    }
    
    var $mediaGallery = $('.jsc-mix-match-media-gallery');
    var isMobile = $(window).width() < 480;
    
    // Find the slider item with alt text containing "base image"
    // On mobile, check for "base image mobile", on desktop check for "base image" (but NOT mobile)
    var $baseImageSliderItem = null;
    
    $mediaGallery.find('.slider__item').each(function() {
        var $item = $(this);
        var $img = $item.find('img');
        var altText = $img.attr('alt') || $item.find('.product-media__label-text').text() || '';
        var altTextLower = altText.toLowerCase();
        
        // Check for base image alt text (mobile or desktop variant)
        var isMatch = false;
        if (isMobile) {
            // Mobile: must include "mobile-mixmatch-base"
            isMatch = altTextLower.includes('mobile-mixmatch-base');
        } else {
            // Desktop: must include "desktop-mixmatch-base"
            isMatch = altTextLower.includes('desktop-mixmatch-base');
        }
        
        if (isMatch) {
            $baseImageSliderItem = $item;
            return false; // Break the loop
        }
    });
    
    // If no base image slider item found, try desktop collage
    if ($baseImageSliderItem === null || $baseImageSliderItem.length === 0) {
        $mediaGallery.find('.product-media-collage__item').each(function() {
            var $item = $(this);
            var $img = $item.find('img');
            var altText = $img.attr('alt') || $item.find('.product-media__label-text').text() || '';
            var altTextLower = altText.toLowerCase();
            
            // Desktop collage: must include "desktop-mixmatch-base"
            if (altTextLower.includes('desktop-mixmatch-base')) {
                $baseImageSliderItem = $item;
                return false; // Break the loop
            }
        });
    }
    
    if ($baseImageSliderItem === null || $baseImageSliderItem.length === 0) {
        return; // No base image found, exit
    }
    
    // Find the product-media div within the base image slider item
    var $productMedia = $baseImageSliderItem.find('.product-media.product-media--image div');
    
    if ($productMedia.length === 0) {
        return;
    }
    
    // Remove existing overlay images (but keep the base image)
    $productMedia.find('img[data-overlay-image]').remove();
    
    // Loop through each bundle wrapper and get ONLY active/selected swatches
    var overlayImages = [];
    
    $('.jsc-bundle-wrapper').each(function() {
        var $bundleWrapper = $(this);
        var $activeSwatch = $bundleWrapper.find('.jsc-swatch-opt.active');
        
        // Only append if a swatch is actually selected (active)
        if ($activeSwatch.length > 0) {
            var desktopImage = $activeSwatch.attr('overlay-image-desktop');
            var mobileImage = $activeSwatch.attr('overlay-image-mobile');
            
            // Determine which image to use based on screen size
            var imageToUse = '';
            if ($(window).width() < 480) {
                // On mobile, try mobile image first, fallback to desktop if empty
                if (mobileImage && mobileImage !== '') {
                    imageToUse = mobileImage;
                } else if (desktopImage && desktopImage !== '') {
                    imageToUse = desktopImage;
                }
            } else if (desktopImage && desktopImage !== '') {
                // On desktop, use desktop image
                imageToUse = desktopImage;
            }
            
            if (imageToUse !== '') {
                overlayImages.push(imageToUse);
            }
        }
    });
    
    // Append overlay images to the base image slider item (only if there are selected swatches)
    overlayImages.forEach(function(imageSrc) {
        var $img = $('<img>').attr('src', imageSrc).attr('data-overlay-image', 'true');
        $productMedia.append($img);
    });
    
    updateAddonOverlayImages();
}

// Set sticky top position for mix match media gallery on mobile
setMixMatchStickyTop = () => {
    if ($(window).width() <= 480 && $('.jsc-mix-match-media-gallery').length > 0) {
        var headerHeight = $('page-header').outerHeight() || 0;
        $('.jsc-mix-match-media-gallery').css('top', headerHeight + 'px');
    }
}

// Initialize sticky bundle ATC for mix match
initMixMatchStickyATC = () => {
    // Only on mobile
    if ($(window).width() >= 480) {
        return;
    }
    
    var $stickyBundleATC = $('.jsc-sticky-bundle-atc-container[mix-match]');
    if ($stickyBundleATC.length === 0) {
        return;
    }
    
    var $bundleSection = $('.jsc-custom-bundle');
    if ($bundleSection.length === 0) {
        return;
    }
    
    // Move sticky ATC to body if not already there
    if (!$stickyBundleATC.parent().is('body')) {
        $('body').append($stickyBundleATC);
    }
    
    // Prevent scrolling beyond top of page
    // var preventOverscroll = function() {
    //     var scrollTop = $(window).scrollTop();
    //     if (scrollTop < 0) {
    //         window.scrollTo(0, 0);
    //     }
    // };
    
    // Throttled scroll handler
    var scrollTimer;
    var checkStickyBundleATC = function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
            // Prevent scrolling beyond top
            // preventOverscroll();
            
            var bundleSectionTop = $bundleSection.offset().top;
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();
            
            // Show sticky ATC when bundle section is scrolled past
            if (scrollTop + windowHeight > bundleSectionTop + 200) {
                $stickyBundleATC.addClass('active');
            } else {
                $stickyBundleATC.removeClass('active');
            }
        }, 10);
    };
    
    // Check on scroll
    $(window).on('scroll', checkStickyBundleATC);
    
    // Also prevent overscroll on touch events (mobile)
    // $(window).on('touchmove', preventOverscroll);
    
    // Initial check
    checkStickyBundleATC();
}

// Trigger bundle ATC from sticky button
triggerBundleStickyATC = (button) => {
    var $button = $(button);
    var fakeTitle = $button.attr('data-fake-title');
    var fakeVid = $button.attr('data-fake-vid');
    var bundleItem = $button.attr('data-bundle-item');
    
    // Find and click the main bundle ATC button
    var $bundleAtcBtn = $('.jsc-bundle-atc');
    if ($bundleAtcBtn.length > 0 && !$button.prop('disabled')) {
        $bundleAtcBtn[0].click();
    }
}

// Helper function to parse price from formatted text (removes currency symbols, etc.)
parsePriceFromText = (priceText) => {
    if (!priceText) return 0;
    return parseFloat(priceText.replace(/[^0-9.-]+/g, '')) || 0;
}

// Helper function to format price with currency symbol
formatPriceWithCurrency = (price, currencySymbol) => {
    return currencySymbol + price.toFixed(2);
}

// Update sticky bundle ATC price
updateStickyBundleATCPrice = () => {
    var $stickyBundleATC = $('.jsc-sticky-bundle-atc-container[mix-match]');
    if ($stickyBundleATC.length === 0) {
        return null;
    }
    var $stickyPriceContainer = $stickyBundleATC.find('.jsc-sticky-bundle-price');
    var $stickyPrice = $stickyPriceContainer.find('.bundle-atc-price');
    var $stickyOriginalPrice = $stickyPriceContainer.find('.bundle-atc-original-price');
    
    if ($stickyPrice.length === 0) {
        return null;
    }
    
    // Get base bundle price from data attribute on sticky price element
    var basePriceText = $stickyPrice.attr('data-base-price');
    var basePrice = parsePriceFromText(basePriceText);
    
    // Get base compare_at_price from data attribute on sticky price element
    var baseCompareAtPriceText = $stickyPrice.attr('data-compare-at-price');
    var baseCompareAtPrice = parsePriceFromText(baseCompareAtPriceText);
    
    // Calculate total addon prices (same as updateBundleAtcPrice)
    var totalAddonPrice = 0;
    var totalAddonOriginalPrice = 0;
    
    $('.addon-checkbox-input:checked').each(function() {
        var $checkbox = $(this);
        var collectionId = $checkbox.attr('data-collection-id');
        var $activeSwatch = $('#addon-swatches-' + collectionId + ' .active.addon-swatch');
        
        if ($activeSwatch.length > 0) {
            var discountedPriceText = $activeSwatch.attr('data-discounted-price');
            var addonPrice = parsePriceFromText(discountedPriceText);
            totalAddonPrice += addonPrice;
            
            // Get addon original price from compare-at-price attribute
            var addonCompareAtPriceText = $activeSwatch.attr('data-compare-at-price');
            var addonOriginalPrice = parsePriceFromText(addonCompareAtPriceText);
            totalAddonOriginalPrice += addonOriginalPrice;
        }
    });
    
    // Calculate new total price (same as updateBundleAtcPrice)
    var newTotalPrice = basePrice + totalAddonPrice;
    
    // Calculate total original price (compare_at_price + addon original prices)
    var totalOriginalPrice = baseCompareAtPrice + totalAddonOriginalPrice;
    
    // Format the new price using currency symbol from data attribute (same as updateBundleAtcPrice)
    var currencySymbol = $stickyPriceContainer.attr('data-currency') || '$';
    var formattedPrice = formatPriceWithCurrency(newTotalPrice, currencySymbol);
    
    // Update base price (red color)
    $stickyPrice.css('color', 'red').text(formattedPrice);
    
    // Show/hide strikethrough price if original price is higher than discounted price (mobile sticky ATC only)
    if (totalOriginalPrice > newTotalPrice && totalOriginalPrice > 0) {
        if ($stickyOriginalPrice.length === 0) {
            // Create strikethrough price element if it doesn't exist
            $stickyOriginalPrice = $('<span class="bundle-atc-original-price struck-out-price" style="margin-left: 5px; text-decoration: line-through; opacity: 0.7;"></span>');
            $stickyPrice.after($stickyOriginalPrice);
        }
        var formattedOriginalPrice = formatPriceWithCurrency(totalOriginalPrice, currencySymbol);
        $stickyOriginalPrice.text(formattedOriginalPrice).show();
    } else if ($stickyOriginalPrice.length > 0) {
        $stickyOriginalPrice.hide();
    }
    
    // Return calculated values for reuse
    return {
        newTotalPrice: newTotalPrice,
        totalOriginalPrice: totalOriginalPrice,
        currencySymbol: currencySymbol
    };
}

// Click base image thumbnail in mix match gallery
scrollToAndClickBaseImageThumbnail = () => {
    // Only apply if jsc-mix-match-media-gallery exists on page
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        return;
    }
    
    var $mediaGallery = $('.jsc-mix-match-media-gallery');
    var isMobile = $(window).width() < 480;
    
    // Loop through all thumbnail images and find the matching one
    $mediaGallery.find('.thumbnails .slider__item').each(function() {
        var $item = $(this);
        var $img = $item.find('img');
        var imgAltText = ($img.attr('alt') || '').toLowerCase();
        
        // Check if this thumbnail matches the base image alt text
        var isMatch = false;
        if (isMobile) {
            // Mobile: must include "mobile-mixmatch-base"
            isMatch = imgAltText.includes('mobile-mixmatch-base');
        } else {
            // Desktop: must include "desktop-mixmatch-base"
            isMatch = imgAltText.includes('desktop-mixmatch-base');
        }
        
        if (isMatch) {
            // Click the thumbnail with a small delay
            setTimeout(function() {
                var $thumbnailLink = $item.find('a.thumbnail.thumbnail--media-image');
                if ($thumbnailLink.length > 0) {
                    $thumbnailLink[0].click();
                }
            }, 100);
            
            return false; // Break the loop
        }
    });
}

onclickAddonCheckboxChange = (checkbox) => {
    var $checkbox = $(checkbox);
    var collectionId = $checkbox.attr('data-collection-id');
    var $swatchesContainer = $('#addon-swatches-' + collectionId);
    var $addonItem = $checkbox.closest('.addon-item');
    var $colorDisplay = $addonItem.find('.addon-color-display');
    
    if ($checkbox.is(':checked')) {
        $swatchesContainer.show();
        $colorDisplay.show();
    } else {
        $swatchesContainer.hide();
        $colorDisplay.hide();
        // Remove active class from all swatches when checkbox is unchecked
        $swatchesContainer.find('.addon-swatch').removeClass('active');
        // Clear error message
        $addonItem.find('.addon-swatch-error').hide().text('');
    }
    
    // Update overlay images when checkbox state changes
    updateAddonOverlayImages();
    
    // Update bundle ATC button price
    updateBundleAtcPrice();
}

onclickAddonSwatchChange = (swatch) => {
    var $swatch = $(swatch);
    var $container = $swatch.closest('.addon-swatches-container');
    var collectionId = $container.attr('id').replace('addon-swatches-', '');
    var $addonItem = $('.addon-checkbox-input[data-collection-id="' + collectionId + '"]').closest('.addon-item');
    
    // Remove active class from other swatches in the same container
    $container.find('.addon-swatch').removeClass('active');
    
    // Add active class to clicked swatch
    $swatch.addClass('active');
    
    // Clear error message when swatch is selected
    $addonItem.find('.addon-swatch-error').hide().text('');
    
    // Update color display
    var colorName = $swatch.attr('data-color');
    var $colorDisplay = $addonItem.find('.addon-color-display');
    $colorDisplay.find('.swatch').text(colorName);
    
    // Update swatch description
    var $swatchDescription = $swatch.attr('data-swatch-description');
    var $descriptionElement = $colorDisplay.find('.bundle-swatch-description');
    if ($swatchDescription && $swatchDescription !== '') {
        if ($descriptionElement.length === 0) {
            $descriptionElement = $('<div class="bundle-swatch-description" style="font-style: italic;"></div>');
            $colorDisplay.find('.swatch').after($descriptionElement);
        }
        $descriptionElement.html($swatchDescription).show();
    } else {
        $descriptionElement.hide().html('');
    }
    
    // Update price display
    var compareAtPrice = $swatch.attr('data-compare-at-price');
    var discountedPrice = $swatch.attr('data-discounted-price');
    var $priceContainer = $addonItem.find('.addon-price-container');
    
    // Update discounted price (already formatted)
    $priceContainer.find('.addon-discounted-price').text(discountedPrice);
    
    // Update original price (compare_at_price) - always show
    var $originalPriceElement = $priceContainer.find('.addon-original-price');
    if ($originalPriceElement.length === 0) {
        // Create the element if it doesn't exist
        $originalPriceElement = $('<span class="addon-original-price struck-out-price"></span>');
        $priceContainer.append($originalPriceElement);
    }
    if (compareAtPrice) {
        $originalPriceElement.text(compareAtPrice);
        $originalPriceElement.show();
    } else {
        // Fallback to regular price if compare_at_price not available
        var regularPrice = $swatch.attr('data-price');
        $originalPriceElement.text(regularPrice);
        $originalPriceElement.show();
    }
    
    // Update addon image
    var featuredImage = $swatch.attr('featured-image');
    if (featuredImage) {
        var $addonImage = $addonItem.find('.addon-image img');
        if ($addonImage.length > 0) {
            $addonImage.attr('src', featuredImage);
        }
    }
    
    // Update overlay images for addon
    updateAddonOverlayImages();
    
    // Update bundle ATC button price
    updateBundleAtcPrice();
}

// Update overlay images for addon items
updateAddonOverlayImages = () => {
    // Only apply if jsc-mix-match-media-gallery exists on page
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        return;
    }
    
    var $mediaGallery = $('.jsc-mix-match-media-gallery');
    var isMobile = $(window).width() < 480;
    
    // Find the base image slider item using helper function
    var $baseImageSliderItem = findMixMatchBaseImage($mediaGallery, isMobile);
    
    if ($baseImageSliderItem === null || $baseImageSliderItem.length === 0) {
        return; // No base image found, exit
    }
    
    // Find the product-media div within the base image slider item
    var $productMedia = $baseImageSliderItem.find('.product-media.product-media--image div');
    
    if ($productMedia.length === 0) {
        return;
    }
    
    // Remove existing addon overlay images
    $productMedia.find('img[data-addon-overlay]').remove();
    
    // Loop through each checked addon and get active swatch
    var addonOverlayImages = [];
    
    $('.addon-checkbox-input:checked').each(function() {
        var $checkbox = $(this);
        var collectionId = $checkbox.attr('data-collection-id');
        var $activeSwatch = $('#addon-swatches-' + collectionId + ' .active.addon-swatch');
        
        // Get overlay images from the selected addon swatch
        if ($activeSwatch.length > 0) {
            var desktopImage = $activeSwatch.attr('overlay-image-desktop');
            var mobileImage = $activeSwatch.attr('overlay-image-mobile');
            
            // Determine which image to use based on screen size
            var imageToUse = '';
            if ($(window).width() < 480) {
                // On mobile, try mobile image first, fallback to desktop if empty
                if (mobileImage && mobileImage !== '') {
                    imageToUse = mobileImage;
                } else if (desktopImage && desktopImage !== '') {
                    imageToUse = desktopImage;
                }
            } else if (desktopImage && desktopImage !== '') {
                // On desktop, use desktop image
                imageToUse = desktopImage;
            }
            
            // Only add image if it exists and is not empty
            if (imageToUse !== '') {
                addonOverlayImages.push(imageToUse);
            }
        }
    });
    
    // Append addon overlay images to the base image slider item
    addonOverlayImages.forEach(function(imageSrc) {
        var $img = $('<img>').attr('src', imageSrc).attr('data-addon-overlay', 'true');
        $productMedia.append($img);
    });
}

// Update bundle ATC button price with addon prices
updateBundleAtcPrice = () => {
    var $bundleAtc = $('.jsc-bundle-atc');
    var $bundleAtcPrice = $bundleAtc.find('.bundle-atc-price');
    
    if ($bundleAtcPrice.length === 0) {
        return; // No price display in button, nothing to update
    }
    
    // Get base bundle price from data attribute (original price)
    var basePriceText = $bundleAtcPrice.attr('data-base-price');
    var basePrice = parsePriceFromText(basePriceText);
    
    // Calculate total addon prices
    var totalAddonPrice = 0;
    
    $('.addon-checkbox-input:checked').each(function() {
        var $checkbox = $(this);
        var collectionId = $checkbox.attr('data-collection-id');
        var $activeSwatch = $('#addon-swatches-' + collectionId + ' .active.addon-swatch');
        
        if ($activeSwatch.length > 0) {
            var discountedPriceText = $activeSwatch.attr('data-discounted-price');
            var addonPrice = parsePriceFromText(discountedPriceText);
            totalAddonPrice += addonPrice;
        }
    });
    
    // Calculate new total price
    var newTotalPrice = basePrice + totalAddonPrice;
    
    // Format the new price using currency symbol from data attribute
    var currencySymbol = $bundleAtc.attr('data-currency') || '$';
    var formattedPrice = formatPriceWithCurrency(newTotalPrice, currencySymbol);
    
    // Update the price display
    $bundleAtcPrice.text(formattedPrice);
    
    // Update sticky bundle ATC price (this also calculates totalOriginalPrice which we can reuse)
    var priceData = updateStickyBundleATCPrice();
    
    // Update jsc-total-bundle-price for mix match only, reusing calculated values
    if ($('.jsc-mix-match-media-gallery').length > 0 && priceData) {
        var $totalBundlePrice = $('.jsc-total-bundle-price');
        if ($totalBundlePrice.length > 0) {
            // Reuse the calculated values from updateStickyBundleATCPrice
            var totalDiscountAmount = priceData.totalOriginalPrice - newTotalPrice;
            
            // Format prices using the already calculated values
            var formattedTotalPrice = formatPriceWithCurrency(newTotalPrice, currencySymbol);
            var formattedCompareAtPrice = formatPriceWithCurrency(priceData.totalOriginalPrice, currencySymbol);
            var formattedDiscountAmount = formatPriceWithCurrency(totalDiscountAmount, currencySymbol);
            
            // Update the price elements
            $totalBundlePrice.find('.total-discount').text(formattedTotalPrice);
            $totalBundlePrice.find('.total-price').text(formattedCompareAtPrice);
            $totalBundlePrice.find('.total-discount-amount').text('Save -' + formattedDiscountAmount);
        }
    }
}

// Filter mix match media gallery images - remove unwanted images and rebuild carousel
// Mobile: keep only images with "mobile-mixmatch-base" or "mobile-display" in alt
// Desktop: keep only images with "desktop-mixmatch-base" in alt, remove mobile images
filterMixMatchMediaGallery = () => {
    // Only apply if jsc-mix-match-media-gallery exists on page
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        return;
    }
    
    var $mediaGallery = $('.jsc-mix-match-media-gallery');
    var isMobile = $(window).width() < 480;
    
    // Filter main carousel - remove unwanted items
    var $mainCarouselSlider = $mediaGallery.find('.main-image carousel-slider');
    if ($mainCarouselSlider.length > 0) {
        var $mainCarousel = $mainCarouselSlider.find('.slider__grid');
        if ($mainCarousel.length > 0) {
            $mainCarousel.find('.slider__item').each(function() {
                var $item = $(this);
                var $img = $item.find('img');
                var altText = $img.attr('alt') || $item.attr('data-alt-text') || $item.find('.product-media__label-text').text() || '';
                var altTextLower = altText.toLowerCase();
                var isMobileBase = altTextLower.includes('mobile-mixmatch-base');
                var isMobileDisplay = altTextLower.includes('mobile-display');
                var isDesktopBase = altTextLower.includes('desktop-mixmatch-base');
                
                if (isMobile) {
                    // Mobile: keep only mobile base and mobile display images, remove desktop base
                    if (isDesktopBase || (!isMobileBase && !isMobileDisplay)) {
                        $item.remove();
                    }
                } else {
                    // Desktop: keep desktop base and remove mobile images
                    if (isMobileBase || isMobileDisplay) {
                        $item.remove();
                    }
                }
            });
            
            // Rebuild main carousel after filtering
            if ($mainCarouselSlider[0] && typeof $mainCarouselSlider[0].refresh === 'function') {
                $mainCarouselSlider[0].refresh();
            }
        }
    }
    
    // Filter thumbnail carousel - remove unwanted thumbnails
    var $thumbnailsCarousel = $mediaGallery.find('.thumbnails carousel-slider, .thumbnails');
    if ($thumbnailsCarousel.length > 0) {
        var $thumbnailsGrid = $thumbnailsCarousel.find('.slider__grid, ul.slider__grid');
        if ($thumbnailsGrid.length > 0) {
            // Get main carousel items for matching by data-media-id
            var $mainCarouselItems = $mediaGallery.find('.main-image .slider__item[data-media-id]');
            if ($mainCarouselItems.length === 0) {
                $mainCarouselItems = $mediaGallery.find('.main-image carousel-slider .slider__grid .slider__item');
            }
            
            $thumbnailsGrid.find('li.slider__item, .slider__item').each(function() {
                var $thumbnailItem = $(this);
                var mediaId = $thumbnailItem.attr('data-media-id');
                var altText = '';
                
                // Try to match with main carousel item by data-media-id
                if (mediaId && $mainCarouselItems.length > 0) {
                    $mainCarouselItems.each(function() {
                        var $mainItem = $(this);
                        if ($mainItem.attr('data-media-id') === mediaId) {
                            var $mainImg = $mainItem.find('img');
                            altText = $mainImg.attr('alt') || $mainItem.attr('data-alt-text') || '';
                            return false;
                        }
                    });
                }
                
                // Fallback: get alt text from thumbnail img
                if (!altText) {
                    var $img = $thumbnailItem.find('img');
                    altText = $img.attr('alt') || '';
                }
                
                var altTextLower = altText.toLowerCase();
                var isMobileBase = altTextLower.includes('mobile-mixmatch-base');
                var isMobileDisplay = altTextLower.includes('mobile-display');
                var isDesktopBase = altTextLower.includes('desktop-mixmatch-base');
                
                if (isMobile) {
                    // Mobile: keep only mobile base and mobile display thumbnails, remove desktop base
                    if (isDesktopBase || (!isMobileBase && !isMobileDisplay)) {
                        $thumbnailItem.remove();
                    }
                } else {
                    // Desktop: keep desktop base and remove mobile thumbnails
                    if (isMobileBase || isMobileDisplay) {
                        $thumbnailItem.remove();
                    }
                }
            });
            
            // Rebuild thumbnail carousel after filtering
            var thumbnailsSlider = $thumbnailsCarousel.is('carousel-slider') ? $thumbnailsCarousel[0] : $thumbnailsCarousel.find('carousel-slider')[0];
            if (thumbnailsSlider && typeof thumbnailsSlider.refresh === 'function') {
                thumbnailsSlider.refresh();
            }
        }
    }
    
    // Filter desktop collage items - remove mobile images
    var $desktopCollage = $mediaGallery.find('.product-media-collage .product-media-collage__item');
    if ($desktopCollage.length > 0) {
            $desktopCollage.each(function() {
                var $item = $(this);
                var $img = $item.find('img');
                var altText = $img.attr('alt') || $item.find('.product-media__label-text').text() || '';
                var altTextLower = altText.toLowerCase();
                var isMobileBase = altTextLower.includes('mobile-mixmatch-base');
                var isMobileDisplay = altTextLower.includes('mobile-display');
                
                // Desktop collage: remove mobile images
                if (isMobileBase || isMobileDisplay) {
                    $item.remove();
                }
            });
    }
    
    // Filter gallery viewer template (before it gets cloned)
    var $galleryViewerTemplate = $mediaGallery.find('.js-media-zoom-template');
    if ($galleryViewerTemplate.length > 0 && $galleryViewerTemplate[0].content) {
        var templateContent = $galleryViewerTemplate[0].content;
        var $templateContent = $(templateContent);
        var $templateThumbs = $templateContent.find('.gallery-viewer__thumb');
        
            $templateThumbs.each(function() {
                var $thumb = $(this);
                var $img = $thumb.find('img');
                var altText = $img.attr('alt') || '';
                var altTextLower = altText.toLowerCase();
                var isMobileBase = altTextLower.includes('mobile-mixmatch-base');
                var isMobileDisplay = altTextLower.includes('mobile-display');
                var isDesktopBase = altTextLower.includes('desktop-mixmatch-base');
                
                if (isMobile) {
                    // Mobile: keep only mobile base and mobile display thumbs, remove desktop base
                    if (isDesktopBase || (!isMobileBase && !isMobileDisplay)) {
                        $thumb.remove();
                    }
                } else {
                    // Desktop: keep desktop base and remove mobile thumbs
                    if (isMobileBase || isMobileDisplay) {
                        $thumb.remove();
                    }
                }
            });
    }
    
    // Helper function to filter gallery viewer modal
    var filterGalleryViewerModal = function($modal) {
        if (!$modal || $modal.length === 0) {
            return;
        }
        
        var currentIsMobile = $(window).width() < 480;
        var $modalThumbs = $modal.find('.gallery-viewer__thumb');
        
        $modalThumbs.each(function() {
            var $thumb = $(this);
            var $img = $thumb.find('img');
            var altText = $img.attr('alt') || '';
            var altTextLower = altText.toLowerCase();
            var isMobileBase = altTextLower.includes('mobile-mixmatch-base');
            var isMobileDisplay = altTextLower.includes('mobile-display');
            var isDesktopBase = altTextLower.includes('desktop-mixmatch-base');
            
            if (currentIsMobile) {
                // Mobile: keep only mobile base and mobile display thumbs, remove desktop base
                if (isDesktopBase || (!isMobileBase && !isMobileDisplay)) {
                    $thumb.remove();
                }
            } else {
                // Desktop: keep desktop base and remove mobile thumbs
                if (isMobileBase || isMobileDisplay) {
                    $thumb.remove();
                }
            }
        });
    };
    
    // Filter any already-cloned gallery viewer modals
    $('.gallery-viewer-modal').each(function() {
        filterGalleryViewerModal($(this));
    });
    
    // Hook into modal open event - filter when modal is opened
    // The modal is cloned and added to body when first opened
    $(document).on('click', '.show-gallery', function() {
        // Small delay to ensure modal is added to DOM
        setTimeout(function() {
            var $modal = $('.gallery-viewer-modal');
            if ($modal.length > 0) {
                filterGalleryViewerModal($modal);
            }
        }, 50);
    });
    
    // Also filter when modal-dialog opens (backup method)
    $(document).on('modal:open', '.gallery-viewer-modal', function() {
        filterGalleryViewerModal($(this));
    });
}

// Disable gallery viewer modal for mix match products on mobile (<= 480px)
disableGalleryViewerForMixMatch = () => {
    // Only apply if jsc-mix-match-media-gallery exists on page
    if ($('.jsc-mix-match-media-gallery').length === 0) {
        return;
    }
    
    var isMobile = $(window).width() <= 480;
    var $showGalleryLinks = $('.jsc-mix-match-media-gallery .show-gallery');
    
    // Only add prevention handler on mobile
    if (isMobile) {
        // Prevent click events on .show-gallery elements for mix match products on mobile
        // Use native addEventListener with capture phase to intercept before other handlers
        $showGalleryLinks.each(function() {
            this.addEventListener('click', disableGalleryViewerClickHandler, true);
        });
    }
}

// Handler function to prevent gallery viewer on mobile for mix match
disableGalleryViewerClickHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
}

// end: Mix Match & Addon Functionality

// Start: validate and sync all GWP before checkout
validateGwpBeforeCheckout = () => {
    $(document).on('click', '[name="checkout"], #update-cart[name="checkout"], a[href*="/checkout"]', function(e) {
        var $target = $(e.target);
        var isCheckoutBtn = $target.is('[name="checkout"]') ||
                           $target.is('#update-cart[name="checkout"]') ||
                           $target.is('a[href*="/checkout"]') ||
                           $target.closest('[name="checkout"]').length > 0 ||
                           $target.closest('#update-cart[name="checkout"]').length > 0 ||
                           $target.closest('a[href*="/checkout"]').length > 0;

        if (!isCheckoutBtn) {
            return true;
        }

        if ($target.closest('.jsc-checkout-loading').length > 0 || jscGetCheckoutButtons().filter('.jsc-checkout-loading').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            return false;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        jscSetCheckoutLoading(true);

        jscEnsureGwpSynced()
            .then(function(synced) {
                jscSetCheckoutLoading(false);
                if (synced) {
                    window.location.href = '/checkout';
                    return;
                }

                console.warn('GWP sync did not fully settle before checkout');
                if (window.location.href.includes('/cart')) {
                    location.reload();
                } else {
                    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                        bubbles: true
                    }));
                }
            })
            .catch(function() {
                jscSetCheckoutLoading(false);
                window.location.href = '/checkout';
            });

        return false;
    });
}
// End: validate and sync all GWP before checkout

// start: hotspot slider 
initHotspotSlider = () => { 
  var $slider = $('.hotspot__cards_panel_slider'); 
  if ($slider.length > 0) { 
    $slider.flickity({ 
      cellAlign: 'left', 
      initialIndex: 0, 
      percentPosition: false, 
      pageDots: true, 
      prevNextButtons: true, 
      adaptiveHeight: false, 
      freeScroll: false, 
      wrapAround: true 
    }); 
  } 
} 
// end: hotspot slider